import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';
import {Button, Select} from 'components-lib';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// import docSignImage from '../../../../../assets/img/docSign.png';
import DoctorModal from '../../doctormodal';
import {createPrescriptionTranslationContext} from '../../../../../utils/prescriptionTranslationUtils';
import translations from '../../translations.json';
import axiosInstance from '../../../helpers/axios/axiosInstance';
import { API_ENDPOINTS, getAuthHeaders } from 'config/api';
import advsLocalTranslations from '../../advs_translated.json';
import medicinesTranslations from './medicines_translations.json';
import ImageCache from '../../../../../services/cache/ImageCache';
import ApiCache from '../../../../../services/cache/ApiCache';
// import './PrescriptionLayout.css'; // Pure CSS layout styles - Removed in favor of embedded styles

const PreviewPageWYSIWYG = ({
                                isOpen,
                                onClose,
                                patientData,
                                doctor,
                                parametersData,
                                allergiesData,
                                complaints,
                                diagnosis,
                                medicinesData,
                                advicesData,
                                followUpDate,
                                selectedLanguage,
                                prescriptionData = null,
                                onPrescpSaved,
                                updateAppointmentStatus
                                // isEmergency,
                            }) => {
    const [consultationData, setConsultationData] = useState({});
    const [doctorData, setDoctorData] = useState(null);
    const [isDoctorModalOpen, setIsDoctorModalOpen] = useState(false);
    const [selectedLang, setSelectedLang] = useState(() => {
        try {
            return selectedLanguage || localStorage.getItem('prescriptionLanguage') || 'english';
        } catch {
            return selectedLanguage || 'english';
        }
    });
    const [printPreferences, setPrintPreferences] = useState(() => {
        try {
            const saved = JSON.parse(localStorage.getItem('printPreferences') || '{}');
            return saved && Object.keys(saved).length ? saved : {
                prescriptionType: 'digital',
                margins: {top: 20, right: 20, bottom: 20, left: 20},
                letterhead: {enabled: false, margins: {top: 20, right: 20, bottom: 20, left: 20}},
                layoutPreferences: {
                    showHeader: true,
                    showPatientDetails: true,
                    showparameters: true,
                    showAllergies: true,
                    showComplaints: true,
                    showDiagnosis: true,
                    showMedicines: true,
                    showInvestigations: true,
                    showPastMedications: true,
                    showAdvice: true,
                    showReferredTo: true,
                    showFollowUp: true,
                    showFooter: true,
                    showQRCode: false,
                    showUPI: true,
                }
            };
        } catch (_) {
            return {
                prescriptionType: 'digital',
                margins: {top: 20, right: 20, bottom: 20, left: 20},
                letterhead: {enabled: false, margins: {top: 20, right: 20, bottom: 20, left: 20}},
                layoutPreferences: {
                    showHeader: true,
                    showPatientDetails: true,
                    showparameters: true,
                    showAllergies: true,
                    showComplaints: true,
                    showDiagnosis: true,
                    showMedicines: true,
                    showInvestigations: true,
                    showPastMedications: true,
                    showAdvice: true,
                    showReferredTo: true,
                    showFollowUp: true,
                    showFooter: true,
                    showQRCode: false,
                    showUPI: true,
                }
            };
        }
    });

    // Reference to the content wrapper for section capture
    const contentRootRef = useRef(null);
    const [capturedCanvases, setCapturedCanvases] = useState([]);

    // PDF-related states as specified in prompt
    const [isBuildingPdf, setIsBuildingPdf] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [showPdfPreview, setShowPdfPreview] = useState(false);
    const [pdfError, setPdfError] = useState(null);

    // Legacy states for backward compatibility
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

    const [isSavingPrescription, setIsSavingPrescription] = useState(false);
    const [pdfBlob, setPdfBlob] = useState(null);

    // Refs to avoid redundant work during PDF generation
    const imageCacheRef = useRef(new Map());
    const autoBuildDelayRef = useRef(null);
    const autoBuildFrameRef = useRef(null);
    const isBuildingPdfRef = useRef(false);
    const pendingBuildRequestRef = useRef(null);
    const fontsReadyPromiseRef = useRef(null);
    const adviceTranslationCacheRef = useRef(new Map());
    const doctorProfileCacheRef = useRef(null);
    const fontStylesheetCacheRef = useRef(new Map());
    const fontFileCacheRef = useRef(new Map());
    const inlinedFontCssRef = useRef('');
    const inlinedFontStyleElRef = useRef(null);

    // Auto-generate PDF preview when the modal opens and UI is shown
    // Reset pdfBlob when print preferences change to ensure fresh generation
    // useEffect(() => {
    //   setPdfBlob(null);
    // }, [printPreferences]);

    // useEffect(() => {
    //   if (isOpen && !pdfBlob && contentRootRef.current) {
    //   Use requestAnimationFrame to ensure all components are rendered and the DOM is updated
    //     requestAnimationFrame(() => {
    //       buildPdf(false);
    //     });
    //   }
    // }, [isOpen, pdfBlob]);

    // Reset pdfBlob when print preferences, consultation data, selected language, doctor data, or emergency status change to ensure fresh generation

    // useEffect(() => {
    //   async function fetchData() {
    //     try {
    //       const appointmentId = localStorage.getItem('APPID_CUR');

    //       if (!appointmentId) {
    //         console.warn('No appointment ID found in localStorage');
    //         SetisEmergency(false); // Default to false if no ID
    //         return;

    //       }

    //       console.log('Fetching appointment details for ID:', appointmentId);

    //       const response = await axiosInstance.get(`https://apitest.kifaytihealth.com/api2/api/appointment/getAppointmentById?id=${appointmentId}`);

    //       if (response.data?.success && response.data.data) {
    //         const apptData = response.data.data;
    //         console.log('Fetched appointment data:', apptData);
    //         const emergencyVal = apptData.isEmergency;
    //         SetisEmergency(emergencyVal);
    //       } else {
    //         console.warn('Failed to fetch appointment data: Invalid response structure', response);
    //         SetisEmergency(false); // Default to false on invalid response
    //       }
    //     } catch (error) {
    //       console.error('Error fetching appointment data:', error);
    //       SetisEmergency(false); // Default to false on error
    //     }
    //   }

    //   fetchData();
    // }, [isEmergency]);

    // Replace the existing handleSavePrescription function with this modified version
    const handleSavePrescription = async () => {
        if (!pdfBlob) {
            await buildPdf(false)
        }

        setIsSavingPrescription(true);

        try {
            console.log("=== SAVE PRESCRIPTION PROCESS STARTED ===");

            // Get auth token from localStorage
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('No auth token found in localStorage');
            }

            // Step 1: Get appointment data to retrieve prescription ID
            console.log("2. Fetching appointment data to get prescription ID...");
            const appointmentId = localStorage.getItem('APPID_CUR');
            if (!appointmentId) {
                throw new Error('No appointment ID found');
            }

            const appointmentResponse = await axiosInstance.get('api/prescription/getPrescriptions', {
                params: {appointment_id: appointmentId}
            });
            console.log("3. Appointment data retrieved:", appointmentResponse.data);
            let prescriptionId = appointmentResponse.data?.data?.[0]?.prescription_id;
            console.log(`Prescription ID: ${prescriptionId}`);
            // alert(`Prescription ID: ${JSON.stringify(appointmentResponse)}`);
            // alert(`Prescription ID: ${prescriptionId}`);
            if (!prescriptionId) {
                console.log("4. No existing prescription ID found");
            } else {
                console.log("4. Prescription ID found from appointment:", prescriptionId);
            }

            // Step 2: Upload PDF blob to get objectUrl
            console.log("7. Uploading PDF blob...");
            const formData = new FormData();
            const fileName = `prescription-apptid-${appointmentId}.pdf`;
            formData.append("file", pdfBlob, fileName);

            // Upload to the specified API endpoint
            const uploadResponse = await axiosInstance.post(
                'api/upload',
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log("8. PDF uploaded successfully:", uploadResponse.data);
            const objectUrl = uploadResponse.data.objectUrl;
            console.log("9. Object URL obtained:", objectUrl);

            // Step 3: Post prescription_id and objectUrl to prescription/upload endpoint
            console.log("10. Saving prescription URL...");
            const uploadDataPayload = {
                id: prescriptionId,
                prescription_url: objectUrl,
            };

            const saveUrlResponse = await axiosInstance.post(
                API_ENDPOINTS.PRESCRIPTION.UPLOAD,
                uploadDataPayload,
                { headers: getAuthHeaders() }
            );
            console.log("11. Prescription URL saved successfully:", saveUrlResponse.data);

            console.log("=== SAVE PRESCRIPTION PROCESS COMPLETED SUCCESSFULLY ===");
            console.log("Prescription saved successfully!");
            if (updateAppointmentStatus) {
                await updateAppointmentStatus();
            }
        } catch (error) {
            console.error("=== SAVE PRESCRIPTION PROCESS FAILED ===");
            console.error("Error details:", error);
            console.error("Error response:", error.response?.data);
            console.error("Error status:", error.response?.status);

            alert(
                `Failed to save prescription: ${error.response?.data?.message || error.message
                }`
            );
        } finally {
            setIsSavingPrescription(false);
            // reload
            // window.location.reload();
            onPrescpSaved(true)
        }
    };

    // Preload and cache <img> assets using global ImageCache to avoid duplicate network requests
    const preloadImages = useCallback(async (element) => {
        if (!element) return;

        const images = element.querySelectorAll('img');
        const imagePromises = Array.from(images).map(async (img) => {
            const currentSrc = img.getAttribute('data-html2canvas-cache-src') || img.currentSrc || img.src;
            if (!currentSrc) return;

            const originalSrc = img.getAttribute('data-html2canvas-original-src') || currentSrc;
            if (!img.getAttribute('data-html2canvas-original-src')) {
                img.setAttribute('data-html2canvas-original-src', originalSrc);
            }

            const src = currentSrc;
            if (!src) return;

            if (src.startsWith('data:') || src.startsWith('blob:')) {
                img.setAttribute('data-html2canvas-cache', src);
                img.setAttribute('data-html2canvas-cache-src', src);
                if (img.src !== src) {
                    img.src = src;
                }
                return;
            }

            if (!img.crossOrigin && /^https?:/i.test(src)) {
                img.crossOrigin = 'anonymous';
            }

            const cachedSrc = img.getAttribute('data-html2canvas-cache-src');
            if (cachedSrc === src && img.getAttribute('data-html2canvas-cache')) {
                return; // already cached for this source
            }

            // Use global ImageCache - fetches only once globally, reused across all renders
            try {
                const dataUrl = await ImageCache.get(src);
                if (dataUrl) {
                    img.setAttribute('data-html2canvas-cache', dataUrl);
                    img.setAttribute('data-html2canvas-cache-src', src);
                    if (img.src !== dataUrl) {
                        img.src = dataUrl;
                    }
                } else {
                    if (img.src !== originalSrc) {
                        img.src = originalSrc;
                    }
                }
            } catch (error) {
                console.warn('preview: unable to cache image', src, error);
                if (img.src !== originalSrc) {
                    img.src = originalSrc;
                }
            }
        });

        await Promise.all(imagePromises);
        console.log(`✅ Preloaded ${images.length} images (global cache size: ${ImageCache.size()})`);
        // Additionally, inline CSS background-images to prevent style-based fetches during cloning
        try {
            const allEls = element.querySelectorAll('*');
            const bgPromises = Array.from(allEls).map(async (el) => {
                try {
                    const computed = window.getComputedStyle(el);
                    const bg = computed.backgroundImage || '';
                    const urlMatch = bg && bg.match(/url\(([^)]+)\)/);
                    if (!urlMatch) return;
                    let url = urlMatch[1].trim().replace(/['"`]/g, '');
                    if (!/^https?:/i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) return;

                    if (!el.crossOrigin) el.crossOrigin = 'anonymous';

                    // Use global ImageCache for background images too - fetches only once globally
                    try {
                        const dataUrl = await ImageCache.get(url);
                        if (dataUrl) {
                            el.style.backgroundImage = `url(${dataUrl})`;
                            el.setAttribute('data-html2canvas-bgcache', dataUrl);
                        }
                    } catch (error) {
                        console.warn('preview: unable to cache background image', url, error);
                    }
                } catch (_) {
                    // ignore individual background fetch failures
                }
            });
            await Promise.all(bgPromises);
            console.log('✅ Inlined background images');
        } catch (err) {
            console.warn('preview: background inlining failed', err);
        }
    }, []);

    const inlineGoogleFonts = useCallback(async () => {
        if (typeof document === 'undefined') return '';

        if (inlinedFontCssRef.current) {
            return inlinedFontCssRef.current;
        }

        // Collect font stylesheet hrefs from <link> and @import rules inside <style> and CSSStyleSheets
        const fontLinkEls = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).filter(link => {
            const href = link.getAttribute('href') || '';
            return /fonts\.googleapis\.com/i.test(href);
        });

        const importHrefs = new Set();
        // scan <style> tags for @import rules
        const styleEls = Array.from(document.querySelectorAll('style'));
        const importRegex = /@import\s+(?:url\()?['"]?([^'")]+)['"]?\)?\s*;?/gi;
        styleEls.forEach(styleEl => {
            let match;
            while ((match = importRegex.exec(styleEl.textContent))) {
                const href = match[1];
                if (/fonts\.googleapis\.com/i.test(href)) importHrefs.add(href);
            }
        });

        // scan document.styleSheets for CSSImportRule entries
        try {
            for (const ss of Array.from(document.styleSheets || [])) {
                try {
                    const rules = ss.cssRules || ss.rules;
                    if (!rules) continue;
                    for (const r of Array.from(rules)) {
                        // CSSImportRule may throw in some browsers, so guard access
                        if (r && r.href && /fonts\.googleapis\.com/i.test(r.href)) {
                            importHrefs.add(r.href);
                        }
                    }
                } catch (_) {
                    // ignore cross-origin stylesheets
                }
            }
        } catch (_) {
        }

        const hrefs = [];
        fontLinkEls.forEach(l => {
            const h = l.getAttribute('href') || '';
            if (h) hrefs.push(h);
        });
        importHrefs.forEach(h => hrefs.push(h));

        // If no external Google Fonts found, mark as complete and return empty (using local fonts only)
        if (!hrefs.length) {
            inlinedFontCssRef.current = 'FONTS_NOT_NEEDED_LOCAL_ONLY';
            return '';
        }

        let storage = null;
        try {
            storage = window.localStorage;
        } catch (_) {
            storage = null;
        }

        const arrayBufferToBase64 = (buffer) => {
            if (typeof window === 'undefined' || typeof window.btoa !== 'function') return '';
            let binary = '';
            const bytes = new Uint8Array(buffer);
            for (let i = 0; i < bytes.byteLength; i += 1) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };

        const convertFontStylesheet = async (href) => {
            if (fontStylesheetCacheRef.current.has(href)) {
                return fontStylesheetCacheRef.current.get(href);
            }

            const storageKey = storage ? `preview-font-css::${href}` : null;
            if (storageKey) {
                const cachedCss = storage.getItem(storageKey);
                if (cachedCss) {
                    fontStylesheetCacheRef.current.set(href, cachedCss);
                    return cachedCss;
                }
            }

            try {
                const response = await fetch(href, {
                    mode: 'cors',
                    credentials: 'omit',
                    cache: 'force-cache'
                });
                const cssText = await response.text();

                const fontUrlRegex = /url\(([^)]+)\)/g;
                const fontUrls = new Set();
                let match;
                while ((match = fontUrlRegex.exec(cssText))) {
                    const rawUrl = match[1]?.trim().replace(/['"]/g, '') || '';
                    if (/^https?:/i.test(rawUrl)) {
                        fontUrls.add(rawUrl);
                    }
                }

                const fetchFontPromises = Array.from(fontUrls).map(async (fontUrl) => {
                    if (fontFileCacheRef.current.has(fontUrl)) return;

                    const fontStorageKey = storage ? `preview-font-file::${fontUrl}` : null;
                    if (fontStorageKey) {
                        const cachedFont = storage.getItem(fontStorageKey);
                        if (cachedFont) {
                            fontFileCacheRef.current.set(fontUrl, cachedFont);
                            return;
                        }
                    }

                    try {
                        const fontResponse = await fetch(fontUrl, {
                            mode: 'cors',
                            credentials: 'omit',
                            cache: 'force-cache'
                        });
                        const buffer = await fontResponse.arrayBuffer();
                        const base64 = arrayBufferToBase64(buffer);
                        if (!base64) return;
                        const extension = fontUrl.split('.').pop() || '';
                        const mime = extension === 'woff2' ? 'font/woff2' : extension === 'woff' ? 'font/woff' : 'application/octet-stream';
                        const dataUrl = `data:${mime};base64,${base64}`;
                        fontFileCacheRef.current.set(fontUrl, dataUrl);
                        if (fontStorageKey) {
                            try {
                                storage.setItem(fontStorageKey, dataUrl);
                            } catch (storageError) {
                                console.warn('preview: unable to persist font file cache', storageError);
                            }
                        }
                    } catch (error) {
                        console.warn('preview: unable to inline font file', fontUrl, error);
                        fontFileCacheRef.current.set(fontUrl, fontUrl);
                    }
                });

                if (fetchFontPromises.length) {
                    await Promise.all(fetchFontPromises);
                }

                const replaceRegex = /url\(([^)]+)\)/g;
                const inlinedCss = cssText.replace(replaceRegex, (fullMatch, rawUrl) => {
                    const cleanUrl = rawUrl?.trim().replace(/['"]/g, '') || '';
                    if (!/^https?:/i.test(cleanUrl)) return fullMatch;
                    const cachedData = fontFileCacheRef.current.get(cleanUrl);
                    if (!cachedData) return fullMatch;
                    if (cachedData.startsWith('data:')) {
                        return `url(${cachedData})`;
                    }
                    return fullMatch;
                });

                fontStylesheetCacheRef.current.set(href, inlinedCss);
                if (storageKey) {
                    try {
                        storage.setItem(storageKey, inlinedCss);
                    } catch (storageError) {
                        console.warn('preview: unable to persist font stylesheet cache', storageError);
                    }
                }
                return inlinedCss;
            } catch (error) {
                console.warn('preview: failed to inline font stylesheet', href, error);
                fontStylesheetCacheRef.current.set(href, '');
                return '';
            }
        };

        const cssList = await Promise.all(hrefs.map(href => convertFontStylesheet(href)));
        const combinedCss = cssList.filter(Boolean).join('\n');

        if (combinedCss) {
            inlinedFontCssRef.current = combinedCss;
            if (!inlinedFontStyleElRef.current) {
                const styleEl = document.createElement('style');
                styleEl.setAttribute('data-inlined-google-fonts', 'true');
                styleEl.textContent = combinedCss;
                document.head.appendChild(styleEl);
                inlinedFontStyleElRef.current = styleEl;
            }
        }

        // Disable or remove original link/import references to avoid further fetches
        fontLinkEls.forEach(link => {
            if (!link.hasAttribute('data-font-inline-processed')) {
                link.setAttribute('data-font-inline-processed', 'true');
                try {
                    link.parentNode?.removeChild(link);
                } catch (_) {
                    link.disabled = true;
                }
            }
        });

        // Remove @import references from <style> elements (they may trigger fetches during cloning)
        if (combinedCss) {
            styleEls.forEach(styleEl => {
                try {
                    if (importRegex.test(styleEl.textContent)) {
                        styleEl.textContent = styleEl.textContent.replace(importRegex, '');
                        styleEl.setAttribute('data-font-import-removed', 'true');
                    }
                } catch (_) {
                }
            });
            // Try to remove CSSImportRule entries from styleSheets where possible
            try {
                for (const ss of Array.from(document.styleSheets || [])) {
                    try {
                        const rules = ss.cssRules || ss.rules;
                        if (!rules) continue;
                        for (let i = rules.length - 1; i >= 0; i--) {
                            const r = rules[i];
                            if (r && r.href && /fonts\.googleapis\.com/i.test(r.href)) {
                                try {
                                    ss.deleteRule(i);
                                } catch (_) { /* ignore */
                                }
                            }
                        }
                    } catch (_) { /* ignore cross-origin */
                    }
                }
            } catch (_) {
            }
        }

        return inlinedFontCssRef.current;
    }, []);

    // Run font inlining early when the preview is opened so remote stylesheets are removed before html2canvas cloning
    useEffect(() => {
        if (isOpen) {
            // fire-and-forget: ensure fonts are inlined before PDF builds
            inlineGoogleFonts().catch(e => console.warn('preview: inlineGoogleFonts early run failed', e));
            // also remove preconnect hints that may trigger fetches
            try {
                Array.from(document.querySelectorAll('link[rel="preconnect"], link[rel="dns-prefetch"]')).forEach(link => {
                    const href = link.getAttribute('href') || '';
                    if (/fonts\.gstatic|fonts\.googleapis/i.test(href)) {
                        try {
                            link.parentNode?.removeChild(link);
                        } catch (_) {
                            link.disabled = true;
                        }
                    }
                });
            } catch (_) {
            }
        }
    }, [isOpen, inlineGoogleFonts]);

    const ensureFontsReady = useCallback(async () => {
        await inlineGoogleFonts();
        try {
            if (!document?.fonts?.ready) return;
            if (!fontsReadyPromiseRef.current) {
                fontsReadyPromiseRef.current = document.fonts.ready.catch(() => null);
            }
            await fontsReadyPromiseRef.current;
        } catch (error) {
            console.warn('preview: font readiness wait failed', error);
        }
    }, [inlineGoogleFonts]);

    // Function to build section canvases
    const buildSectionCanvases = useCallback(async (rootEl) => {
        if (!rootEl) return [];

        try {
            await ensureFontsReady();
            await preloadImages(rootEl);

            // Look for both old .section class and new .prescription-section class
            // Note: Don't include .prescription-content as it's a wrapper div
            // IMPORTANT: Capture .prescription-compact-grid as ONE section, not individual children
            const allSections = Array.from(rootEl.querySelectorAll('.section, .prescription-section, .prescription-header, .prescription-footer, .prescription-patient-bar, .prescription-compact-grid'));

            const topLevelSections = allSections.filter(section => {
                // Exclude sections that are inside the compact grid (they'll be captured with the grid)
                if (section.classList.contains('prescription-section')) {
                    let parent = section.parentElement;
                    while (parent && parent !== rootEl) {
                        if (parent.classList && parent.classList.contains('prescription-compact-grid')) {
                            return false; // Skip this section, it's inside the grid
                        }
                        parent = parent.parentElement;
                    }
                }

                // Exclude nested sections
                let current = section.parentElement;
                while (current && current !== rootEl) {
                    if (current.classList && (current.classList.contains('section') || current.classList.contains('prescription-section'))) {
                        return false;
                    }
                    current = current.parentElement;
                }
                return true;
            });

            console.log(`🔍 Found ${topLevelSections.length} top-level sections to capture`);

            const deviceScale = typeof window !== 'undefined' ? (window.devicePixelRatio || 1) : 1;
            const captureScale = Math.min(2.6, Math.max(1.5, deviceScale));

            const canvasResults = [];

            for (const element of topLevelSections) {
                try {
                    if (element.offsetParent === null) continue;

                    const canvas = await html2canvas(element, {
                        scale: captureScale,
                        backgroundColor: '#fff',
                        useCORS: true,
                        allowTaint: true,
                        logging: false,
                        width: element.scrollWidth,
                        height: element.scrollHeight,
                        scrollX: 0,
                        scrollY: 0,
                        foreignObjectRendering: false,
                        skipFonts: true,
                        onclone: (clonedDoc) => {
                            // Remove all font-related stylesheets to prevent loading
                            clonedDoc
                                .querySelectorAll('link[rel="stylesheet"]')
                                .forEach(link => {
                                    const href = link.getAttribute('href') || '';
                                    // Remove Google Fonts, local fonts, and any font-face imports
                                    if (/fonts\.googleapis|fonts\.gstatic|fonts-local/i.test(href)) {
                                        link.parentNode?.removeChild(link);
                                    }
                                });

                            // Remove any style tags that define @font-face
                            clonedDoc.querySelectorAll('style').forEach(style => {
                                if (/@font-face|googleapis|gstatic/i.test(style.textContent)) {
                                    style.parentNode?.removeChild(style);
                                }
                            });

                            const allElements = clonedDoc.querySelectorAll('*');
                            allElements.forEach(el => {
                                const computedStyle = window.getComputedStyle(el);
                                if (computedStyle.color && computedStyle.color !== 'rgb(0, 0, 0)') {
                                    el.style.color = '#000000 !important';
                                }
                                if (computedStyle.backgroundColor === 'rgba(0, 0, 0, 0)' ||
                                    computedStyle.backgroundColor === 'transparent') {
                                    el.style.backgroundColor = 'transparent';
                                } else if (computedStyle.backgroundColor !== 'rgb(255, 255, 255)') {
                                    el.style.backgroundColor = '#ffffff';
                                }
                                // Use system font fallback instead of web fonts
                                if (computedStyle.fontFamily) {
                                    el.style.fontFamily = 'Arial, Helvetica, sans-serif';
                                }
                                if (computedStyle.fontWeight && computedStyle.fontWeight !== 'normal') {
                                    el.style.fontWeight = computedStyle.fontWeight;
                                }
                                if (el.tagName === 'IMG') {
                                    const cached = el.getAttribute('data-html2canvas-cache');
                                    if (cached) {
                                        el.setAttribute('crossorigin', 'anonymous');
                                        el.src = cached;
                                    }
                                }
                            });
                        }
                    });

                    canvasResults.push({element, canvas});
                } catch (error) {
                    console.warn('Failed to capture section:', element, error);
                }
            }

            console.log(`✅ Successfully captured ${canvasResults.length} section canvases`);
            return canvasResults;
        } catch (error) {
            console.error('Error in buildSectionCanvases:', error);
            return [];
        }
    }, [ensureFontsReady, preloadImages]);

    // Test canvas capture functionality
    // eslint-disable-next-line no-unused-vars
    const handleCaptureTest = async () => {
        try {
            console.log('🧪 Starting comprehensive canvas test...');

            // First, test with a simple element to verify html2canvas is working
            console.log('📝 Testing with simple element...');
            const testDiv = document.createElement('div');
            testDiv.innerHTML = '<p style="color: #000; font-family: Arial; font-size: 16px; padding: 20px; background: white;">Simple Test Content</p>';
            testDiv.style.position = 'absolute';
            testDiv.style.top = '-9999px';
            testDiv.style.left = '0';
            testDiv.style.backgroundColor = 'white';
            testDiv.style.width = '300px';
            testDiv.style.height = '100px';
            document.body.appendChild(testDiv);

            const testCanvas = await html2canvas(testDiv, {
                scale: 2,
                backgroundColor: '#ffffff',
                useCORS: true,
                logging: true,
                onclone: (clonedDoc) => {
                    console.log('🔧 Applying styles to cloned document...');
                    const style = clonedDoc.createElement('style');
                    style.innerHTML = `
            * { 
              color: #000000 !important; 
              font-family: Arial, sans-serif !important; 
              background: white !important;
            }
          `;
                    clonedDoc.head.appendChild(style);
                }
            });

            document.body.removeChild(testDiv);
            console.log(`✅ Test canvas created: ${testCanvas.width}x${testCanvas.height}`);

            // Analyze test canvas
            const testCtx = testCanvas.getContext('2d');
            const testImageData = testCtx.getImageData(0, 0, testCanvas.width, testCanvas.height);
            const testPixels = testImageData.data;
            let testNonWhitePixels = 0;

            for (let i = 0; i < testPixels.length; i += 4) {
                const r = testPixels[i];
                const g = testPixels[i + 1];
                const b = testPixels[i + 2];
                const a = testPixels[i + 3];

                if (a > 0 && (r !== 255 || g !== 255 || b !== 255)) {
                    testNonWhitePixels++;
                }
            }

            const testHasContent = testNonWhitePixels > 0;
            console.log(`🎯 Test canvas analysis: ${testNonWhitePixels} non-white pixels, hasContent: ${testHasContent}`);

            if (!testHasContent) {
                console.error('❌ Basic html2canvas test failed - no content captured');
                alert('html2canvas appears to not be working correctly. This may be a browser compatibility issue.');
                return;
            }

            // Now test with actual content
            if (!contentRootRef.current) {
                console.error('❌ Content root ref not found');
                alert('Content reference not found. Please ensure the page has loaded properly.');
                return;
            }

            console.log('📸 Capturing actual content sections...');
            const canvases = await buildSectionCanvases(contentRootRef.current);
            console.log(`📊 Captured ${canvases.length} section canvases`);

            if (canvases.length === 0) {
                console.warn('⚠️ No sections found for capture');
                alert('No sections found. Please ensure content has .section class applied.');
                return;
            }

            // Analyze each canvas
            let totalContentCanvases = 0;
            canvases.forEach((item, index) => {
                const {element, canvas} = item;
                console.log(`📋 Canvas ${index + 1}:`, {
                    elementTag: element.tagName,
                    elementClass: element.className,
                    canvasSize: `${canvas.width}x${canvas.height}`,
                    elementText: element.textContent.substring(0, 100) + '...'
                });

                // Enhanced content analysis
                const ctx = canvas.getContext('2d');
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const pixels = imageData.data;

                let nonWhitePixels = 0;
                let coloredPixels = 0;

                for (let i = 0; i < pixels.length; i += 4) {
                    const r = pixels[i];
                    const g = pixels[i + 1];
                    const b = pixels[i + 2];
                    const a = pixels[i + 3];

                    if (a > 0) { // Non-transparent
                        if (r !== 255 || g !== 255 || b !== 255) {
                            nonWhitePixels++;
                            if (r < 200 || g < 200 || b < 200) { // Darker colors
                                coloredPixels++;
                            }
                        }
                    }
                }

                const totalPixels = pixels.length / 4;
                const hasContent = nonWhitePixels > 0;

                console.log(`🎨 Canvas ${index + 1} analysis:`, {
                    hasContent,
                    nonWhitePixels,
                    coloredPixels,
                    totalPixels,
                    contentPercentage: ((nonWhitePixels / totalPixels) * 100).toFixed(2) + '%',
                    darkContentPercentage: ((coloredPixels / totalPixels) * 100).toFixed(2) + '%'
                });

                if (hasContent) totalContentCanvases++;

                if (!hasContent) {
                    console.warn(`⚠️ Canvas ${index + 1} appears to be empty (all white/transparent)`);
                } else if (coloredPixels === 0) {
                    console.warn(`⚠️ Canvas ${index + 1} may have very light content that won't show in PDF`);
                }
            });

            console.log(`📈 Summary: ${totalContentCanvases}/${canvases.length} canvases have visible content`);

            setCapturedCanvases(canvases);

            // Visual preview with both test and actual canvases
            const tempContainer = document.createElement('div');
            tempContainer.style.cssText = `
        position: fixed;
        top: 10px;
        left: 10px;
        z-index: 10000;
        background: white;
        border: 2px solid red;
        padding: 15px;
        max-height: 500px;
        overflow-y: auto;
        max-width: 90vw;
        font-family: Arial, sans-serif;
      `;

            // Add test result
            const testHeader = document.createElement('h3');
            testHeader.textContent = `Test Canvas (${testHasContent ? 'SUCCESS' : 'FAILED'}):`;
            testHeader.style.cssText = `margin: 0 0 10px 0; color: ${testHasContent ? 'green' : 'red'};`;
            tempContainer.appendChild(testHeader);

            const testImg = document.createElement('img');
            testImg.src = testCanvas.toDataURL();
            testImg.style.cssText = 'max-width: 200px; border: 1px solid black; margin-bottom: 15px; display: block;';
            tempContainer.appendChild(testImg);

            // Add results summary
            const summary = document.createElement('p');
            summary.textContent = `Captured ${canvases.length} sections, ${totalContentCanvases} with visible content`;
            summary.style.cssText = 'font-weight: bold; margin: 0 0 15px 0;';
            tempContainer.appendChild(summary);

            // Add actual canvases
            canvases.forEach((item, index) => {
                const label = document.createElement('p');
                label.textContent = `Section ${index + 1}:`;
                label.style.cssText = 'margin: 10px 0 5px 0; font-weight: bold;';
                tempContainer.appendChild(label);

                const img = document.createElement('img');
                img.src = item.canvas.toDataURL();
                img.style.cssText = 'max-width: 300px; border: 1px solid black; margin-bottom: 10px; display: block;';
                tempContainer.appendChild(img);
            });

            const closeBtn = document.createElement('button');
            closeBtn.textContent = 'Close Preview';
            closeBtn.style.cssText = `
        padding: 8px 15px;
        background: red;
        color: white;
        border: none;
        cursor: pointer;
        font-size: 14px;
        margin-top: 10px;
      `;
            closeBtn.onclick = () => document.body.removeChild(tempContainer);
            tempContainer.appendChild(closeBtn);

            document.body.appendChild(tempContainer);

        } catch (error) {
            console.error('❌ Error during comprehensive canvas test:', error);
            alert(`Canvas test failed: ${error.message}\n\nCheck browser console for details.`);
        }
    };

    // Build PDF with page flow logic (debounced and concurrency-safe)
    const buildPdf = useCallback(async (download = false) => {
        if (!contentRootRef.current) return null;

        if (isBuildingPdfRef.current) {
            const existing = pendingBuildRequestRef.current;
            if (existing) {
                existing.download = existing.download || download;
                return existing.promise;
            }

            let resolvePending;
            let rejectPending;
            const promise = new Promise((resolve, reject) => {
                resolvePending = resolve;
                rejectPending = reject;
            });
            pendingBuildRequestRef.current = {
                download,
                resolve: resolvePending,
                reject: rejectPending,
                promise
            };
            return promise;
        }

        isBuildingPdfRef.current = true;
        setIsBuildingPdf(true);
        setIsGeneratingPdf(true);
        setPdfError(null);

        try {
            const doc = new jsPDF('portrait', 'mm', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            const margins = {
                top: 6,
                bottom: 6,
                left: 10,
                right: 10,
                sectionGap: 3,
                headerToContentGap: 3,
            };

            const availableWidth = pageWidth - margins.left - margins.right;

            const canvases = await buildSectionCanvases(contentRootRef.current);
            console.log(`📄 Building PDF with ${canvases.length} sections`);

            if (canvases.length === 0) {
                const error = 'No content found to generate PDF. Please ensure the preview has loaded properly.';
                setPdfError(error);
                alert(error);
                return null;
            }

            canvases.forEach((item, index) => {
                console.log(`Canvas ${index}: ${item.canvas.width}x${item.canvas.height}, Element: ${item.element.className}`);
            });

            let headerCanvas = null;
            let footerCanvas = null;
            let contentCanvases = [];

            canvases.forEach((item, index) => {
                const className = item.element.className || '';
                if (index === 0 || className.includes('prescription-header')) {
                    headerCanvas = item.canvas;
                } else if (className.includes('prescription-footer')) {
                    footerCanvas = item.canvas;
                } else {
                    contentCanvases.push(item);
                }
            });

            if (!headerCanvas && canvases.length > 0) {
                headerCanvas = canvases[0].canvas;
                contentCanvases = canvases.slice(1);
            }

            let currentY = margins.top;
            let currentPage = 1;

            const addHeaderToPage = () => {
                if (!headerCanvas) return 0;

                const headerHeight = (headerCanvas.height * availableWidth) / headerCanvas.width;
                console.log(`Adding header: ${availableWidth}mm x ${headerHeight}mm`);

                try {
                    doc.addImage(
                        headerCanvas.toDataURL('image/png', 1.0),
                        'PNG',
                        margins.left,
                        margins.top,
                        availableWidth,
                        headerHeight,
                        undefined,
                        'FAST'
                    );
                } catch (error) {
                    console.error('Error adding header image:', error);
                }

                return headerHeight + margins.headerToContentGap;
            };

            if (headerCanvas) {
                const headerHeight = addHeaderToPage();
                currentY += headerHeight;
            } else {
                currentY += margins.headerToContentGap;
            }

            // Calculate footer height if it exists (we'll reserve space for it)
            let footerHeight = 0;
            if (footerCanvas) {
                footerHeight = (footerCanvas.height * availableWidth) / footerCanvas.width;
            }

            for (let i = 0; i < contentCanvases.length; i++) {
                const {canvas} = contentCanvases[i];

                const sectionHeight = (canvas.height * availableWidth) / canvas.width;
                const spaceNeeded = sectionHeight + margins.sectionGap;

                // Check if this is the last section to determine if we need footer space
                const isLastSection = (i === contentCanvases.length - 1);
                const bottomReserve = isLastSection ? margins.bottom : margins.bottom;
                const remainingSpace = pageHeight - currentY - bottomReserve - (isLastSection ? footerHeight : 0);

                console.log(`Section ${i}: needs ${spaceNeeded}mm, available ${remainingSpace}mm (page ${currentPage})`);

                // If section doesn't fit, add new page
                if (spaceNeeded > remainingSpace && remainingSpace < pageHeight * 0.3) {
                    console.log(`Section ${i} doesn't fit (${spaceNeeded}mm > ${remainingSpace}mm), creating new page`);
                    doc.addPage();
                    currentPage++;
                    currentY = margins.top;

                    if (headerCanvas) {
                        const headerHeight = addHeaderToPage();
                        currentY += headerHeight;
                    } else {
                        currentY += margins.headerToContentGap;
                    }
                }

                console.log(`Adding section ${i}: ${availableWidth}mm x ${sectionHeight}mm at Y=${currentY}mm`);

                try {
                    doc.addImage(
                        canvas.toDataURL('image/png', 1.0),
                        'PNG',
                        margins.left,
                        currentY,
                        availableWidth,
                        sectionHeight,
                        undefined,
                        'FAST'
                    );

                    currentY += sectionHeight + margins.sectionGap;

                } catch (error) {
                    console.error(`Error adding section ${i}:`, error);
                    setPdfError(`Error adding section ${i}: ${error.message}`);
                }
            }

            // Add footer naturally after last section if it exists
            if (footerCanvas) {
                const footerHeightActual = (footerCanvas.height * availableWidth) / footerCanvas.width;
                const spaceNeeded = footerHeightActual + margins.sectionGap;
                const remainingSpace = pageHeight - currentY - margins.bottom;

                // Check if footer fits on current page
                if (spaceNeeded > remainingSpace && remainingSpace < pageHeight * 0.3) {
                    console.log(`Footer doesn't fit, creating new page`);
                    doc.addPage();
                    currentPage++;
                    currentY = margins.top;

                    if (headerCanvas) {
                        const headerHeight = addHeaderToPage();
                        currentY += headerHeight;
                    }
                }

                console.log(`Adding footer: ${availableWidth}mm x ${footerHeightActual}mm at Y=${currentY}mm (flowing with content)`);

                try {
                    doc.addImage(
                        footerCanvas.toDataURL('image/png', 1.0),
                        'PNG',
                        margins.left,
                        currentY, // Place at current Y position instead of bottom
                        availableWidth,
                        footerHeightActual,
                        undefined,
                        'FAST'
                    );
                    currentY += footerHeightActual; // Update currentY after footer
                } catch (error) {
                    console.error('Error adding footer image:', error);
                }
            }

            const totalPages = doc.internal.getNumberOfPages();
            for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
                doc.setPage(pageNum);
                doc.setFontSize(10);
                doc.text(`Page No. ${pageNum}/${totalPages}`, pageWidth / 2, pageHeight - 5, {align: 'center'});
            }

            console.log(`✅ PDF generated successfully with ${totalPages} pages`);

            if (download) {
                const appointmentId = localStorage.getItem('APPID_CUR') || 'unknown';
                doc.save(`prescription-appt-${appointmentId}.pdf`);
                return null;
            }

            const generatedBlob = doc.output('blob');
            setPdfBlob(generatedBlob);
            const blobUrl = URL.createObjectURL(generatedBlob);
            setPdfUrl((prevUrl) => {
                if (prevUrl) URL.revokeObjectURL(prevUrl);
                return blobUrl;
            });
            return generatedBlob;

        } catch (error) {
            console.error('Error generating PDF:', error);
            const errorMessage = `PDF generation failed: ${error.message}. Please try again or check the browser console for details.`;
            setPdfError(errorMessage);
            alert(errorMessage);
            throw error;
        } finally {
            isBuildingPdfRef.current = false;
            setIsBuildingPdf(false);
            setIsGeneratingPdf(false);

            const pending = pendingBuildRequestRef.current;
            if (pending) {
                pendingBuildRequestRef.current = null;
                requestAnimationFrame(() => {
                    buildPdf(pending.download)
                        .then(pending.resolve)
                        .catch(pending.reject);
                });
            }
        }
    }, [buildSectionCanvases]);

    const schedulePdfBuild = useCallback((download = false) => {
        if (!isOpen) return;

        if (autoBuildDelayRef.current) {
            clearTimeout(autoBuildDelayRef.current);
            autoBuildDelayRef.current = null;
        }

        if (autoBuildFrameRef.current) {
            cancelAnimationFrame(autoBuildFrameRef.current);
            autoBuildFrameRef.current = null;
        }

        if (typeof window === 'undefined') {
            buildPdf(download);
            return;
        }

        autoBuildDelayRef.current = window.setTimeout(() => {
            autoBuildDelayRef.current = null;
            autoBuildFrameRef.current = window.requestAnimationFrame(() => {
                autoBuildFrameRef.current = null;
                buildPdf(download).catch((error) => {
                    console.error('Scheduled PDF build failed', error);
                });
            });
        }, 120);
    }, [buildPdf, isOpen]);

    useEffect(() => {
        if (!isOpen) return;
        setPdfBlob(null);
        setPdfUrl((prevUrl) => {
            if (prevUrl) URL.revokeObjectURL(prevUrl);
            return null;
        });
        schedulePdfBuild(false);
    }, [consultationData, doctorData, isOpen, printPreferences, schedulePdfBuild, selectedLang]);

    useEffect(() => () => {
        if (autoBuildDelayRef.current) {
            clearTimeout(autoBuildDelayRef.current);
            autoBuildDelayRef.current = null;
        }
        if (autoBuildFrameRef.current) {
            cancelAnimationFrame(autoBuildFrameRef.current);
            autoBuildFrameRef.current = null;
        }
    }, []);

    useEffect(() => {
        if (isOpen) return;
        if (autoBuildDelayRef.current) {
            clearTimeout(autoBuildDelayRef.current);
            autoBuildDelayRef.current = null;
        }
        if (autoBuildFrameRef.current) {
            cancelAnimationFrame(autoBuildFrameRef.current);
            autoBuildFrameRef.current = null;
        }
    }, [isOpen]);

    // Handle PDF generation for preview
    // eslint-disable-next-line no-unused-vars
    const handlePdfPreview = () => {
        buildPdf(false);
    };

    // Handle PDF download
    const handlePdfDownload = async () => {
        // Ensure content is rendered before generating PDF
        if (!contentRootRef.current) {
            alert('Please wait for the prescription to load before downloading.');
            return;
        }

        // Check if there are any sections to capture
        const sections = contentRootRef.current.querySelectorAll('.section, .prescription-section, .prescription-header, .prescription-footer, .prescription-patient-bar');
        if (sections.length === 0) {
            alert('No content found. Please wait for the prescription to load completely.');
            return;
        }

        if (pdfBlob) {
            // If pdfBlob exists, create a download link for it
            const blobUrl = URL.createObjectURL(pdfBlob);
            const a = document.createElement('a');
            a.href = blobUrl;
            const apptId = localStorage.getItem('APPID_CUR') || 'unknown';
            a.download = `prescription-apptid-${apptId}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(blobUrl);
        } else {
            // No existing PDF blob — generate & download a fresh PDF
            await buildPdf(true);
        }
    };

    const handlePdfPrint = async () => {
        // Implement print functionality here
        // Ensure content is rendered before generating PDF
        if (!contentRootRef.current) {
            alert('Please wait for the prescription to load before downloading.');
            return;
        }

        // Check if there are any sections to capture
        const sections = contentRootRef.current.querySelectorAll('.section, .prescription-section, .prescription-header, .prescription-footer, .prescription-patient-bar');
        if (sections.length === 0) {
            alert('No content found. Please wait for the prescription to load completely.');
            return;
        }

        if (pdfBlob) {
            // If pdfBlob exists, create a download link for it
            const blobUrl = URL.createObjectURL(pdfBlob);
            // 2. Open the Blob in a new window
            const newWindow = window.open(blobUrl);
            // 3. Wait until the PDF is loaded, then trigger print
            newWindow.onload = () => {
                newWindow.focus();
                newWindow.print();
            }
        } else {
            // No existing PDF blob — generate & download a fresh PDF
            await buildPdf(true);
        }
    };

    // Close PDF preview
    // eslint-disable-next-line no-unused-vars
    const closePdfPreview = () => {
        setShowPdfPreview(false);
        if (pdfUrl) {
            URL.revokeObjectURL(pdfUrl);
            setPdfUrl(null);
        }
        if (pdfPreviewUrl) {
            URL.revokeObjectURL(pdfPreviewUrl);
            setPdfPreviewUrl(null);
        }
    };

    // Persist selected language
    useEffect(() => {
        try {
            localStorage.setItem('prescriptionLanguage', selectedLang);
        } catch (_) {
        }
    }, [selectedLang]);

    // Translation context memoized by language
    const tctx = useMemo(() => createPrescriptionTranslationContext(selectedLang), [selectedLang]);

    // Header translation helper: prefer local translations.json, then bulk API, then English fallback
    const trHeader = (key, englishText) => {
        // For medicine-related headers, prioritize medicine translations
        const medicineHeaders = ['medicines', 'medicine', 'dosage', 'duration', 'type', 'frequency', 'how to take'];
        if (medicineHeaders.includes(key.toLowerCase()) || medicineHeaders.includes(englishText.toLowerCase())) {
            const viaMedicine = translateMedicineTerm(englishText, selectedLang);
            if (viaMedicine && viaMedicine !== englishText && String(viaMedicine).trim()) {
                return viaMedicine;
            }
        }

        const viaLocal = tctx?.labels?.[key];
        if (viaLocal && String(viaLocal).trim()) return viaLocal;
        const viaBulk = bulkTranslations?.[englishText];
        if (viaBulk && String(viaBulk).trim()) return viaBulk;

        // Try medicine translations as final fallback for any header
        const viaMedicine = translateMedicineTerm(englishText, selectedLang);
        if (viaMedicine && viaMedicine !== englishText && String(viaMedicine).trim()) return viaMedicine;
        return englishText;
    };

    // Map our UI language to API language codes
    const getLanguageCode = useCallback((lang) => {
        const languageMap = {
            hindi: 'hi',
            bengali: 'bn',
            marathi: 'mr',
            telugu: 'te',
            tamil: 'ta',
            gujarati: 'gu',
            assamese: 'as',
            kannada: 'kn',
            malayalam: 'ml',
            punjabi: 'pa',
            english: 'en',
        };
        return languageMap[lang] || 'en';
    }, []);

    const ADVICE_TRANSLATIONS_KEY = 'advice_translations_cache_v1';

    const getAdviceIdentifier = (entry) => {
        if (!entry) return null;
        if (typeof entry === 'object') {
            return (
                entry.id || entry.advice_id || entry.adviceId || entry.ADVICE_ID || null
            );
        }
        const normalized = String(entry || '').trim();
        return normalized || null;
    };

    const buildAdviceEntriesFromProps = useCallback(() => {
        const current =
            consultationData?.advicesData || consultationData?.advice || advicesData || [];
        const asArray = Array.isArray(current) ? current : current ? [current] : [];
        return asArray
            .map((adv) => {
                if (!adv) return null;
                const id = getAdviceIdentifier(adv);
                const text =
                    typeof adv === 'object'
                        ? String(adv.advice || adv.details || adv.text || '')
                        : null;
                return {id, text};
            })
            .filter(Boolean);
    }, [consultationData?.advicesData, consultationData?.advice, advicesData]);

    // Advice translations cache by id: text
    const [adviceTranslations, setAdviceTranslations] = useState({});

    // Persist advice translations (id or text) into localStorage in a safe, merge-friendly way
    const persistAdviceTranslation = (id, text, translations) => {
        try {
            const raw = localStorage.getItem(ADVICE_TRANSLATIONS_KEY) || '{}';
            const store = JSON.parse(raw || '{}');

            const normText = text ? String(text).trim() : null;

            // Normalize translations to an array form when possible
            let tx = [];
            if (Array.isArray(translations)) tx = translations;
            else if (translations && typeof translations === 'object') {
                // object keyed by language -> translation
                tx = Object.keys(translations).map((k) => ({language: k, translation: translations[k]}));
            }

            if (id) {
                const key = String(id);
                store[key] = store[key] || {};
                if (tx.length) store[key].translations = tx;
                if (normText) store[key].text = normText;
            } else if (normText) {
                // fallback: store by normalized text key if no id
                const found = Object.keys(store).find(k => (store[k] && (store[k].text || '').toString().trim().toLowerCase()) === normText.toLowerCase());
                const useKey = found || `text::${normText.toLowerCase().slice(0, 64)}`;
                store[useKey] = store[useKey] || {};
                if (tx.length) store[useKey].translations = tx;
                store[useKey].text = normText;
            }

            try {
                localStorage.setItem(ADVICE_TRANSLATIONS_KEY, JSON.stringify(store));
            } catch (_) {
            }
        } catch (_) { /* ignore storage failures */
        }
    };

    const fetchAdviceTranslations = useCallback(
        async (adviceEntries, languageCode) => {
            if (!adviceEntries || adviceEntries.length === 0) {
                return {};
            }

            let storage = {};
            try {
                const raw = localStorage.getItem(ADVICE_TRANSLATIONS_KEY) || '{}';
                storage = JSON.parse(raw || '{}');
            } catch (_) {
                storage = {};
            }

            const translationsMap = {};
            try {
                console.debug('fetchAdviceTranslations: entries=', adviceEntries, 'languageCode=', languageCode);
            } catch (_) {
            }
            const idsToFetch = [];

            const normalized = adviceEntries
                .map((e) => {
                    if (!e) return null;
                    if (typeof e === 'object') {
                        return {
                            id: getAdviceIdentifier(e) || null,
                            text: e.text || e.advice || e.advice_text || e.details || null,
                        };
                    }
                    return {id: getAdviceIdentifier(e), text: null};
                })
                .filter(Boolean);

            normalized.forEach(({id, text}) => {
                if (!id) {
                    idsToFetch.push({id: null, text: (text || '').toString().trim()});
                    return;
                }
                const textNorm = (text || '').toString().trim();
                const textKey = textNorm ? `:${textNorm.toLowerCase()}` : '';
                const cacheKey = `${id}:${languageCode}${textKey}`;

                if (adviceTranslationCacheRef.current.has(cacheKey)) {
                    const cached = adviceTranslationCacheRef.current.get(cacheKey);
                    if (cached) translationsMap[id] = cached;
                    try {
                        console.debug('runtime cache hit:', cacheKey, id);
                    } catch (_) {
                    }
                    return;
                }

                const storedEntry = storage && storage[id];
                if (storedEntry && Array.isArray(storedEntry.translations)) {
                    const storedText = (storedEntry.text || '').toString().trim();
                    if (storedText && textNorm && storedText !== textNorm) {
                        idsToFetch.push({id, text: textNorm});
                        return;
                    }

                    const match = storedEntry.translations.find((item) => {
                        const raw = (item?.language_code || item?.language || item?.lang || '').toString().toLowerCase();
                        const selLang = (languageCode || '').toString().toLowerCase();
                        try {
                            if (raw === languageCode) return item?.translation;
                            if (raw === selLang) return item?.translation;
                            if (getLanguageCode(raw) === languageCode) return item?.translation;
                            if (raw.startsWith(languageCode) || languageCode.startsWith(raw)) return item?.translation;
                        } catch (_) {
                        }
                        return false;
                    });
                    if (match && match.translation) {
                        translationsMap[id] = match.translation;
                        adviceTranslationCacheRef.current.set(cacheKey, match.translation);
                        try {
                            console.debug('found in localStorage for id:', id, 'language=', languageCode);
                        } catch (_) {
                        }
                        try {
                            if (textNorm) {
                                const tkey = `text:${textNorm.toLowerCase()}`;
                                translationsMap[tkey] = match.translation;
                                adviceTranslationCacheRef.current.set(`${tkey}:${languageCode}`, match.translation);
                            }
                        } catch (_) {
                        }
                        return;
                    }
                }

                idsToFetch.push({id, text: textNorm});
            });

            normalized.forEach(({id, text}) => {
                if (id) return;
                const textNorm = (text || '').toString().trim();
                if (!textNorm) return;
                for (const k of Object.keys(storage)) {
                    try {
                        const se = storage[k];
                        const seText = (se && se.text) ? se.text.toString().trim() : '';
                        const seNorm = (se && se.norm)
                            ? se.norm.toString().trim().toLowerCase()
                            : seText
                                ? seText.toLowerCase()
                                : '';
                        try {
                            const seTransArr = Array.isArray(se && se.translations) ? se.translations : [];
                            if (seTransArr.length) {
                                const foundByTranslatedText = seTransArr.find((tt) => tt?.translation && tt.translation.toString().trim().toLowerCase() === textNorm.toLowerCase());
                                if (foundByTranslatedText) {
                                    const maybeTrans = seTransArr.find((item) => {
                                        const raw = (item?.language_code || item?.language || item?.lang || '').toString().toLowerCase();
                                        try {
                                            if (raw === languageCode) return true;
                                            if (getLanguageCode(raw) === languageCode) return true;
                                            if (raw.startsWith(languageCode) || languageCode.startsWith(raw)) return true;
                                        } catch (_) {
                                        }
                                        return false;
                                    });
                                    if (maybeTrans && maybeTrans.translation) {
                                        const key = `text:${textNorm.toLowerCase()}`;
                                        translationsMap[key] = maybeTrans.translation;
                                        try {
                                            adviceTranslationCacheRef.current.set(`${key}:${languageCode}`, maybeTrans.translation);
                                        } catch (_) {
                                        }
                                        try {
                                            console.debug('reverse-lookup: mapped DOM translated text to target language via storage:', key, languageCode);
                                        } catch (_) {
                                        }
                                        break;
                                    }
                                }
                            }
                        } catch (_) {
                            /* ignore */
                        }
                        if (!seText) continue;
                        if (seNorm && seNorm === textNorm.toLowerCase()) {
                            if (Array.isArray(se.translations)) {
                                const match = se.translations.find((item) => {
                                    const raw = (item?.language_code || item?.language || item?.lang || '').toString().toLowerCase();
                                    try {
                                        if (raw === languageCode) return true;
                                        if (raw === (selectedLang || '').toString().toLowerCase()) return true;
                                        if (getLanguageCode(raw) === languageCode) return true;
                                        if (raw.startsWith(languageCode) || languageCode.startsWith(raw)) return true;
                                    } catch (_) {
                                    }
                                    return false;
                                });
                                if (match && match.translation) {
                                    const key = `text:${textNorm.toLowerCase()}`;
                                    translationsMap[key] = match.translation;
                                    try {
                                        adviceTranslationCacheRef.current.set(`${key}:${languageCode}`, match.translation);
                                    } catch (_) {
                                    }
                                    try {
                                        console.debug('found in localStorage by text:', key, languageCode);
                                    } catch (_) {
                                    }
                                }
                            }
                            break;
                        }
                    } catch (_) {
                    }
                }
            });

            if (!idsToFetch.length) return translationsMap;

            try {
                const requests = idsToFetch.map(({id}) =>
                    ApiCache.get(`/api/prescription/getAdvicesTranslation?advice_id=${id}`, {
                        axiosInstance,
                    })
                        .then((res) => ({id, data: res?.data?.data}))
                        .catch((err) => ({id, error: true}))
                );

                const results = await Promise.all(requests);
                try {
                    console.debug('fetchAdviceTranslations: api results count', results.length);
                } catch (_) {
                }
                results.forEach((r, idx) => {
                    const id = r.id || (idsToFetch[idx] && idsToFetch[idx].id);
                    const text = (idsToFetch[idx] && idsToFetch[idx].text) || '';
                    const textKey = text ? `:${text.toString().trim().toLowerCase()}` : '';
                    const cacheKey = `${id}:${languageCode}${textKey}`;
                    if (r.error) {
                        adviceTranslationCacheRef.current.set(cacheKey, null);
                        return;
                    }
                    const data = r.data;
                    if (Array.isArray(data)) {
                        const match = data.find((item) => {
                            const raw = (item?.language_code || item?.language || item?.lang || '').toString().toLowerCase();
                            const selLang = (selectedLang || '').toString().toLowerCase();
                            try {
                                if (raw === languageCode) return item?.translation;
                                if (raw === selLang) return item?.translation;
                                if (getLanguageCode(raw) === languageCode) return item?.translation;
                                if (raw.startsWith(languageCode) || languageCode.startsWith(raw)) return item?.translation;
                            } catch (_) {
                            }
                            return false;
                        });
                        if (match && match.translation) {
                            translationsMap[id] = match.translation;
                            adviceTranslationCacheRef.current.set(cacheKey, match.translation);
                            try {
                                console.debug('fetched translation for id:', id, 'language=', languageCode);
                            } catch (_) {
                            }
                            try {
                                console.debug('advice translation found in localStorage by id:', id, languageCode);
                            } catch (_) {
                            }
                            try {
                                const textLower = (text || '').toString().trim().toLowerCase();
                                if (textLower) {
                                    const tkey = `text:${textLower}`;
                                    translationsMap[tkey] = match.translation;
                                    adviceTranslationCacheRef.current.set(`${tkey}:${languageCode}`, match.translation);
                                    try {
                                        console.debug('also mapping by text:', tkey, languageCode);
                                    } catch (_) {
                                    }
                                }
                            } catch (_) {
                            }
                            return;
                        }
                    }
                    adviceTranslationCacheRef.current.set(cacheKey, null);
                });

                try {
                    const raw2 = localStorage.getItem(ADVICE_TRANSLATIONS_KEY) || '{}';
                    const storage2 = JSON.parse(raw2 || '{}');
                    results.forEach((r, idx) => {
                        const id2 = r.id || (idsToFetch[idx] && idsToFetch[idx].id);
                        const text2 = (idsToFetch[idx] && idsToFetch[idx].text) || '';
                        if (!id2) return;
                        if (r.error) {
                            storage2[id2] = storage2[id2] || {
                                translations: [],
                                text: text2 || storage2[id2]?.text || null
                            };
                        } else if (Array.isArray(r.data)) {
                            storage2[id2] = {translations: r.data, text: text2 || storage2[id2]?.text || null};
                        } else {
                            storage2[id2] = storage2[id2] || {
                                translations: [],
                                text: text2 || storage2[id2]?.text || null
                            };
                        }
                    });
                    localStorage.setItem(ADVICE_TRANSLATIONS_KEY, JSON.stringify(storage2));
                } catch (_) {
                    /* ignore localStorage failures */
                }
            } catch (e) {
                console.error('Error fetching advice translations', e);
            }

            return translationsMap;
        },
        [getLanguageCode, selectedLang]
    );
    const applyAdviceTranslationsToDom = useCallback(
        (map) => {
            if (selectedLang === 'english') return;
            const root = contentRootRef?.current;
            if (!root) return;
            const nodes = root.querySelectorAll('[data-advice-id], [data-adviceid], [data-advice]');
            nodes.forEach((el) => {
                try {
                    const aid = el.getAttribute('data-advice-id') || el.getAttribute('data-adviceid') || el.getAttribute('data-advice');
                    const domText = (el.textContent || '').toString().trim();
                    let translated = null;
                    if (aid) {
                        translated = map[aid];
                        if (!translated) {
                            const ck1 = `${aid}:${getLanguageCode(selectedLang)}`;
                            if (adviceTranslationCacheRef.current.has(ck1)) {
                                translated = adviceTranslationCacheRef.current.get(ck1);
                            }
                        }
                    }
                    if (!translated && domText) {
                        const tkey = `text:${domText.toLowerCase()}`;
                        translated = map[tkey];
                        if (!translated) {
                            const fallback = adviceTranslationCacheRef.current.get(`${tkey}:${getLanguageCode(selectedLang)}`);
                            if (fallback) translated = fallback;
                        }
                    }
                    if (translated && domText !== translated) {
                        el.textContent = translated;
                        el.setAttribute('data-advice-translated', getLanguageCode(selectedLang));
                    }
                } catch (_) {
                }
            });
        },
        [selectedLang, getLanguageCode]
    );

    const loadAdviceTranslations = useCallback(async () => {
        try {
            const entries = buildAdviceEntriesFromProps();
            if (!entries.length) {
                setAdviceTranslations({});
                return;
            }

            const combinedEntries = [...entries];
            try {
                const root = contentRootRef?.current;
                if (root) {
                    const els = root.querySelectorAll('[data-advice-id], [data-adviceid], [data-advice]');
                    els.forEach((el) => {
                        try {
                            const attr = el.getAttribute('data-advice-id') || el.getAttribute('data-adviceid') || el.getAttribute('data-advice');
                            const id = attr ? String(attr).trim() : null;
                            const text = el.textContent ? String(el.textContent || '').trim() : null;
                            if (!id && !text) return;
                            const exists = combinedEntries.some((entry) =>
                                (entry.id && id && String(entry.id) === String(id)) ||
                                (entry.text && text && entry.text.trim() === text.trim())
                            );
                            if (!exists) combinedEntries.push({id, text});
                        } catch (_) {
                        }
                    });
                }
            } catch (_) {
            }

            const langCode = getLanguageCode(selectedLang);
            const translationsMap = await fetchAdviceTranslations(combinedEntries, langCode);
            if (selectedLang === 'english') {
                setAdviceTranslations({});
                return;
            }

            setAdviceTranslations(translationsMap);
            applyAdviceTranslationsToDom(translationsMap);
            try {
                schedulePdfBuild(false);
            } catch (_) {
            }
        } catch (error) {
            console.error('loadAdviceTranslations error', error);
            setAdviceTranslations({});
        }
    }, [buildAdviceEntriesFromProps, selectedLang, getLanguageCode, fetchAdviceTranslations, applyAdviceTranslationsToDom, schedulePdfBuild]);

    // Bulk translations cache for external API
    const [bulkTranslations, setBulkTranslations] = useState({});

    // Helper: map UI language to advs JSON keys
    const getAdvsLangName = (lang) => {
        const map = {
            english: 'Advice (English)',
            hindi: 'Hindi',
            bengali: 'Bengali',
            marathi: 'Marathi',
            telugu: 'Telugu',
            tamil: 'Tamil',
            gujarati: 'Gujarati',
            kannada: 'Kannada',
            malayalam: 'Malayalam',
            punjabi: 'Punjabi',
            assamese: 'Assamese',
        };
        return map[lang] || 'Advice (English)';
    };

    // Localize digits to selected language's numeral system
    const localizeDigits = (text, lang) => {
        if (text === null || text === undefined) return text;
        const s = String(text);
        const arabic = '0123456789';
        const maps = {
            hindi: '०१२३४५६७८९', marathi: '०१२३४५६७८९',
            bengali: '০১২৩৪৫৬৭৮৯', assamese: '০১২৩৪৫৬৭৮৯',
            gujarati: '૦૧૨૩૪૫૬૭૮૯', punjabi: '੦੧੨੩੪੫੬੭੮੯',
            tamil: '௦௧௨௩௪௫௬௭௮௯', telugu: '౦౧౨౩౪౫౬౭౮౯',
            kannada: '೦೧೨೩೪೫೬೭೮೯', malayalam: '൦൧൨൩൪൫൬൭൮൯',
        };
        const tgt = maps[lang];
        if (!tgt) return s;
        let out = '';
        for (const ch of s) {
            const i = arabic.indexOf(ch);
            out += i >= 0 ? tgt[i] : ch;
        }
        return out;
    };

    // // Translate medicine-related terms using medicines_translations.json
    // const translateMedicineTerm = (englishTerm, targetLanguage) => {
    //   // Quick checks
    //   if (!englishTerm || !targetLanguage || targetLanguage === 'english') return englishTerm;

    //   // Map language codes to proper case language names used in the JSON
    //   const languageMap = {
    //     'hindi': 'Hindi',
    //     'bengali': 'Bengali',
    //     'marathi': 'Marathi',
    //     'telugu': 'Telugu',
    //     'tamil': 'Tamil',
    //     'gujarati': 'Gujarati',
    //     'assamese': 'Assamese',
    //     'kannada': 'Kannada',
    //     'malayalam': 'Malayalam',
    //     'punjabi': 'Punjabi'
    //   };

    //   const targetLangName = languageMap[String(targetLanguage).toLowerCase()];
    //   if (!targetLangName) return englishTerm;

    //   // Normalize term: trim, collapse spaces, remove surrounding punctuation
    //   const normalize = (s) => String(s || '').trim().replace(/\s+/g, ' ').replace(/^[-:;,.]+|[-:;,.]+$/g, '');
    //   const stripParens = (s) => String(s || '').replace(/\s*\([^)]*\)\s*/g, ' ').trim();

    //   const termRaw = String(englishTerm);
    //   const termToMatch = normalize(stripParens(termRaw));
    //   const termLower = termToMatch.toLowerCase();

    //   // Helper: find entry by english key (case-insensitive)
    //   const findEntryByEnglish = (key) => medicinesTranslations.find(entry =>
    //     entry.English && String(entry.English).toLowerCase() === String(key).toLowerCase()
    //   );

    //   // 1) Try exact entry match
    //   let entry = findEntryByEnglish(termToMatch) || findEntryByEnglish(termLower);
    //   if (entry && entry[targetLangName]) return entry[targetLangName];

    //   // 2) Try some normalized variations (space/comma normalized, parens removed)
    //   const variations = [
    //     termToMatch,
    //     termLower,
    //     termToMatch.replace(/,\s*/g, ' '),
    //     stripParens(termToMatch),
    //     termToMatch.replace(/\s*\([^)]*\)\s*/g, ''),
    //   ];
    //   for (const v of variations) {
    //     entry = findEntryByEnglish(v);
    //     if (entry && entry[targetLangName]) return entry[targetLangName];
    //   }

    //   // 3) If the whole phrase contains punctuation like commas or slashes, try splitting into tokens
    //   const splitCandidates = termToMatch.split(/[,/]+| and | & |\band\b|\s+/).map(t => normalize(t)).filter(Boolean);
    //   if (splitCandidates.length > 1) {
    //     const translatedParts = splitCandidates.map(token => {
    //       const e = findEntryByEnglish(token) || findEntryByEnglish(token.toLowerCase());
    //       if (e && e[targetLangName]) return e[targetLangName];
    //       // fallback to bulk translation cache for the token
    //       if (bulkTranslations && bulkTranslations[token]) return bulkTranslations[token];
    //       return token; // leave token as-is
    //     });
    //     // If any token translated, join using original separators logic (prefer comma if original had comma)
    //     const joiner = termToMatch.includes(',') ? ', ' : ' ';
    //     if (translatedParts.some((p, i) => p !== splitCandidates[i])) return translatedParts.join(joiner);
    //   }

    //   // 4) Generic 'with' handling anywhere in the phrase: translate 'with' and the object(s)
    //   if (termLower.includes('with ')) {
    //     // split by 'with' and translate left/right parts, but usually right side is what matters
    //     const parts = termRaw.split(/with/i).map(p => p.trim()).filter(Boolean);
    //     if (parts.length >= 2) {
    //       // left = before 'with', right = after; translate right side tokens then prefix with translated 'with' or combine naturally
    //       const left = normalize(parts[0]);
    //       const right = normalize(parts.slice(1).join(' with '));

    //       const withT = (findEntryByEnglish('with') && findEntryByEnglish('with')[targetLangName]) || (bulkTranslations && bulkTranslations['with']) || 'with';
    //       const rightTranslated = translateMedicineTerm(right, targetLanguage);
    //       const leftTranslated = left ? translateMedicineTerm(left, targetLanguage) : '';

    //       // Prefer natural order: rightTranslation + ' ' + withTranslation (as per earlier logic), but if left exists, include it
    //       if (rightTranslated && rightTranslated !== right) {
    //         if (leftTranslated && leftTranslated !== left) return `${leftTranslated} ${rightTranslated} ${withT}`;
    //         return `${rightTranslated} ${withT}`;
    //       }
    //     }
    //   }

    //   // 5) Per-word token fallback: attempt to translate each word individually
    //   const words = termToMatch.split(/\s+/).map(w => normalize(w)).filter(Boolean);
    //   if (words.length > 1) {
    //     const perWord = words.map(w => {
    //       const e = findEntryByEnglish(w) || findEntryByEnglish(w.toLowerCase());
    //       if (e && e[targetLangName]) return e[targetLangName];
    //       if (bulkTranslations && (bulkTranslations[w] || bulkTranslations[w.toLowerCase()])) return bulkTranslations[w] || bulkTranslations[w.toLowerCase()];
    //       return w;
    //     });
    //     if (perWord.some((p, i) => p !== words[i])) return perWord.join(' ');
    //   }

    //   // 6) Try manual common fallbacks (small set)
    //   const commonFallbacks = {
    //     'units': { 'Hindi': 'इकाइयाँ', 'Bengali': 'ইউনিট', 'Marathi': 'युनिट्स', 'Telugu': 'యూనిట్లు', 'Tamil': 'அலகுகள்', 'Gujarati': 'યુનિટ્સ', 'Assamese': 'ইউনিট', 'Kannada': 'ಘಟಕಗಳು', 'Malayalam': 'യൂണിറ്റുകൾ', 'Punjabi': 'ਯੂਨਿਟ' },
    //     'days': { 'Hindi': 'दिन', 'Bengali': 'দিন', 'Marathi': 'दिवस', 'Telugu': 'రోజులు', 'Tamil': 'நாட்கள்', 'Gujarati': 'દિવસ', 'Assamese': 'দিন', 'Kannada': 'ದಿನಗಳು', 'Malayalam': 'ദിവസങ്ങൾ', 'Punjabi': 'ਦਿਨ' },
    //   };
    //   const cb = commonFallbacks[termLower];
    //   if (cb && cb[targetLangName]) return cb[targetLangName];

    //   // 7) Bulk translations as a final fallback for the full phrase
    //   if (bulkTranslations && (bulkTranslations[termRaw] || bulkTranslations[termToMatch])) return bulkTranslations[termRaw] || bulkTranslations[termToMatch];

    //   // Nothing found - log once and return marked placeholder (avoid silent English fallback)
    //   // console.warn(`Translation failed for: "${englishTerm}" in ${targetLanguage}`);
    //   return `${englishTerm}`;
    // };

    // Simple, generalized medicine/term translator using JSON indexes + fallbacks
    // - Uses medicines_translations.json as primary source
    // - Falls back to translations.json (UI labels) and bulkTranslations cache
    // - Handles simple parenthesis stripping and per-word fallbacks
    const medicinesIndex = useMemo(() => {
        const idx = new Map();
        try {
            (medicinesTranslations || []).forEach((entry) => {
                const key = String(entry.English || entry.english || '').trim();
                if (key) idx.set(key.toLowerCase(), entry);
            });
        } catch (_) { /* noop */
        }
        return idx;
    }, []);

    const translateMedicineTerm = (englishTerm, targetLanguage) => {
        if (!englishTerm) return englishTerm;
        const langKey = String((targetLanguage || selectedLang || 'english')).toLowerCase();
        if (langKey === 'english') return englishTerm;

        // Map to the capitalized column name used by medicines_translations.json (e.g. "Hindi")
        const langNameMap = {
            hindi: 'Hindi', bengali: 'Bengali', marathi: 'Marathi', telugu: 'Telugu',
            tamil: 'Tamil', gujarati: 'Gujarati', assamese: 'Assamese',
            kannada: 'Kannada', malayalam: 'Malayalam', punjabi: 'Punjabi'
        };
        const targetLangName = langNameMap[langKey] || null;

        const normalize = (s) => String(s || '').trim().replace(/\s+/g, ' ');
        const raw = normalize(englishTerm);
        // remove parenthetical content for matching (but preserve original for output fallback)
        const withoutParens = raw.replace(/\s*\([^)]*\)\s*/g, ' ').trim();

        const lookup = (key) => {
            if (!key) return null;
            const lower = key.toLowerCase();
            // 1) exact medicines JSON match
            const entry = medicinesIndex.get(lower);
            if (entry && targetLangName && entry[targetLangName]) return String(entry[targetLangName]).trim();
            // 2) translations.json (UI labels) as fallback
            if (translations && translations[langKey] && translations[langKey][key]) return String(translations[langKey][key]).trim();
            // 3) bulkTranslations cache (API) as final fallback
            if (bulkTranslations && (bulkTranslations[key] || bulkTranslations[lower])) return bulkTranslations[key] || bulkTranslations[lower];
            return null;
        };

        // Try progressively more relaxed matches
        const tries = [
            raw,
            withoutParens,
            raw.toLowerCase(),
            withoutParens.toLowerCase()
        ];
        for (const t of tries) {
            const v = lookup(t);
            if (v) return v;
        }

        // If phrase contains separators, try translating tokens and rejoin
        const tokens = withoutParens.split(/[,/]+|\s+and\s+|\s*&\s+|\s+/i).map(t => normalize(t)).filter(Boolean);
        if (tokens.length > 1) {
            const translated = tokens.map(tok => lookup(tok) || tok);
            // if at least one token changed, return joined translation
            if (translated.some((p, i) => p !== tokens[i])) {
                // prefer comma if original had commas, otherwise space
                const joiner = raw.includes(',') ? ', ' : ' ';
                return translated.join(joiner);
            }
        }

        // Per-word fallback (keeps order)
        if (withoutParens.split(/\s+/).length > 1) {
            const words = withoutParens.split(/\s+/);
            const perWord = words.map(w => lookup(w) || w);
            if (perWord.some((p, i) => p !== words[i])) return perWord.join(' ');
        }

        // Last-resort: try translations.json for the exact phrase keys (different casing)
        if (translations && translations[langKey]) {
            const t1 = translations[langKey][raw] || translations[langKey][withoutParens] || translations[langKey][raw.toLowerCase()];
            if (t1) return t1;
        }

        // Nothing found -> return original (do not mark) to avoid noisy UI; still log for debugging
        // This keeps behavior predictable and easy to trace during development
        // eslint-disable-next-line no-console
        console.debug(`translateMedicineTerm: no translation for "${englishTerm}" -> "${langKey}"`);
        return englishTerm;
    };


    // Fetch advice translations only when needed and language is not English
    useEffect(() => {
        // adviceEntries: array of values that may be id strings/numbers OR objects { id, text }
        const fetchAdviceTranslations = async (adviceEntries, languageCode) => {
            if (!adviceEntries || adviceEntries.length === 0 || languageCode === 'en') {
                return {};
            }

            const ADVICE_TRANSLATIONS_KEY = 'advice_translations_cache_v1';
            let storage = {};
            try {
                const raw = localStorage.getItem(ADVICE_TRANSLATIONS_KEY) || '{}';
                storage = JSON.parse(raw || '{}');
            } catch (_) {
                storage = {};
            }

            const translationsMap = {};
            try {
                console.debug('fetchAdviceTranslations: entries=', adviceEntries, 'languageCode=', languageCode);
            } catch (_) {
            }
            const idsToFetch = [];

            // Normalize adviceEntries to array of { id, text }
            const normalized = adviceEntries.map((e) => {
                if (!e) return null;
                if (typeof e === 'object') return {
                    id: e.id || e.advice_id || null,
                    text: (e.text || e.advice || e.advice_text || '').toString()
                };
                return {id: e, text: null};
            }).filter(Boolean);


            // 1. Recover missing IDs using textInputsData/doctorRecommendations/manual scan
            // This is crucial if we only have text but no ID
            const missingIdEntries = normalized.filter(e => !e.id && e.text);
            if (missingIdEntries.length > 0) {
                let textToIdMap = new Map();

                // Helper to index data
                const indexData = (list) => {
                    if (!Array.isArray(list)) return;
                    list.forEach(item => {
                        if (typeof item === 'object' && item && item.id && (item.advice || item.text || item.advice_text)) {
                            const txt = (item.advice || item.text || item.advice_text || '').toString().trim().toLowerCase();
                            if (txt && item.id) textToIdMap.set(txt, item.id);
                        }
                    });
                };

                // Check textInputsData

                // Check full doctor advices list (explicitly cached by AdviceSection)
                try {
                    const fullRaw = localStorage.getItem('doctor_advices_full_list');
                    if (fullRaw) {
                        const fullList = JSON.parse(fullRaw);
                        indexData(fullList);
                    }
                } catch (_) {
                }

                // try {
                //   const tiRaw = localStorage.getItem('textInputsData');
                //   const tiData = tiRaw ? JSON.parse(tiRaw) : {};
                //   if (tiData.advice) indexData(tiData.advice);
                // } catch (_) { }

                // // Check doctorRecommendations
                // try {
                //   const drRaw = localStorage.getItem('doctorRecommendations');
                //   const drData = drRaw ? JSON.parse(drRaw) : {};
                //   // doctorRecommendations.advices is now array of {id, text} thanks to previous step
                //   if (drData.advices) indexData(drData.advices);
                // } catch (_) { }
                // Try to recover IDs
                missingIdEntries.forEach(entry => {
                    const low = entry.text.toLowerCase();
                    if (textToIdMap.has(low)) {
                        entry.id = textToIdMap.get(low);
                        try {
                            console.debug('Recovered ID for advice text:', entry.text, '->', entry.id);
                        } catch (_) {
                        }
                    }
                });
            }

            normalized.forEach(({id, text}) => {
                if (!id) return;
                const textNorm = (text || '').toString().trim();
                const textKey = textNorm ? `:${textNorm.toLowerCase()}` : '';
                const cacheKey = `${id}:${languageCode}${textKey}`;

                // runtime cache first (includes text in cache key)
                if (adviceTranslationCacheRef.current.has(cacheKey)) {
                    const cached = adviceTranslationCacheRef.current.get(cacheKey);
                    if (cached) translationsMap[id] = cached;
                    try {
                        console.debug('runtime cache hit:', cacheKey, id);
                    } catch (_) {
                    }
                    return;
                }

                // then localStorage persistent cache — only use if stored text matches current text
                const storedEntry = storage && storage[id];
                if (storedEntry && Array.isArray(storedEntry.translations)) {
                    const storedText = (storedEntry.text || '').toString().trim();
                    if (storedText && textNorm && storedText !== textNorm) {
                        // text differs: treat as missing so we fetch fresh translations
                        idsToFetch.push({id, text: textNorm});
                        return;
                    }

                    const match = storedEntry.translations.find((item) => {
                        const raw = (item?.language_code || item?.language || item?.lang || '').toString().toLowerCase();
                        const selLang = (languageCode || '').toString().toLowerCase();
                        try {
                            if (raw === languageCode) return item?.translation;
                            if (raw === selLang) return item?.translation;
                            if (getLanguageCode(raw) === languageCode) return item?.translation;
                            if (raw.startsWith(languageCode) || languageCode.startsWith(raw)) return item?.translation;
                        } catch (_) {
                        }
                        return false;
                    });
                    if (match && match.translation) {
                        translationsMap[id] = match.translation;
                        adviceTranslationCacheRef.current.set(cacheKey, match.translation);
                        try {
                            console.debug('found in localStorage for id:', id, 'language=', languageCode);
                        } catch (_) {
                        }
                        try {
                            if (textNorm) {
                                const tkey = `text:${textNorm.toLowerCase()}`;
                                translationsMap[tkey] = match.translation;
                                adviceTranslationCacheRef.current.set(`${tkey}:${languageCode}`, match.translation);
                            }
                        } catch (_) {
                        }
                        return;
                    }
                }

                idsToFetch.push({id, text: textNorm});
            });

            // Handle entries without id (and couldn't recover it) -> try local storage by text
            normalized.forEach(({id, text}) => {
                if (id) return; // already handled
                const textNorm = (text || '').toString().trim();
                if (!textNorm) return;
                // find any storage entry with matching text
                for (const k of Object.keys(storage)) {
                    try {
                        const se = storage[k];
                        const seText = (se && se.text) ? se.text.toString().trim() : '';
                        const seNorm = (se && se.norm) ? se.norm.toString().trim().toLowerCase() : (seText ? seText.toLowerCase() : '');
                        // reverse lookup: if a stored translation text matches the DOM text, map to target language
                        try {
                            const seTransArr = Array.isArray(se && se.translations) ? se.translations : [];
                            if (seTransArr.length) {
                                const foundByTranslatedText = seTransArr.find((tt) => tt?.translation && tt.translation.toString().trim().toLowerCase() === textNorm.toLowerCase());
                                if (foundByTranslatedText) {
                                    const maybeTrans = seTransArr.find((item) => {
                                        const raw = (item?.language_code || item?.language || item?.lang || '').toString().toLowerCase();
                                        try {
                                            if (raw === languageCode) return true;
                                            if (getLanguageCode(raw) === languageCode) return true;
                                            if (raw.startsWith(languageCode) || languageCode.startsWith(raw)) return true;
                                        } catch (_) {
                                        }
                                        return false;
                                    });
                                    if (maybeTrans && maybeTrans.translation) {
                                        const key = `text:${textNorm.toLowerCase()}`;
                                        translationsMap[key] = maybeTrans.translation;
                                        try {
                                            adviceTranslationCacheRef.current.set(`${key}:${languageCode}`, maybeTrans.translation);
                                        } catch (_) {
                                        }
                                        try {
                                            console.debug('reverse-lookup: mapped DOM translated text to target language via storage:', key, languageCode);
                                        } catch (_) {
                                        }
                                        break;
                                    }
                                }
                            }
                        } catch (_) {
                            /* ignore */
                        }
                        if (!seText) continue;
                        if (seNorm && seNorm === textNorm.toLowerCase()) {
                            // try to find language entry inside se.translations
                            if (Array.isArray(se.translations)) {
                                const match = se.translations.find((item) => {
                                    const raw = (item?.language_code || item?.language || item?.lang || '').toString().toLowerCase();
                                    try {
                                        if (raw === languageCode) return true;
                                        if (raw === (selectedLang || '').toString().toLowerCase()) return true;
                                        if (getLanguageCode(raw) === languageCode) return true;
                                        if (raw.startsWith(languageCode) || languageCode.startsWith(raw)) return true;
                                    } catch (_) {
                                    }
                                    return false;
                                });
                                if (match && match.translation) {
                                    const key = `text:${textNorm.toLowerCase()}`;
                                    translationsMap[key] = match.translation;
                                    try {
                                        adviceTranslationCacheRef.current.set(`${key}:${languageCode}`, match.translation);
                                    } catch (_) {
                                    }
                                    try {
                                        console.debug('found in localStorage by text:', key, languageCode);
                                    } catch (_) {
                                    }
                                }
                            }
                            break;
                        }
                    } catch (_) {
                    }
                }
            });

            if (!idsToFetch.length) return translationsMap;

            try {
                const requests = idsToFetch.map(({id}) =>
                    axiosInstance
                        .get(`/api/prescription/getAdvicesTranslation?advice_id=${id}`)
                        .then((res) => ({id, data: res?.data?.data}))
                        .catch((err) => ({id, error: true}))
                );

                const results = await Promise.all(requests);
                try {
                    console.debug('fetchAdviceTranslations: api results count', results.length);
                } catch (_) {
                }
                results.forEach((r, idx) => {
                    const id = r.id || (idsToFetch[idx] && idsToFetch[idx].id);
                    const text = (idsToFetch[idx] && idsToFetch[idx].text) || '';
                    const textKey = text ? `:${text.toString().trim().toLowerCase()}` : '';
                    const cacheKey = `${id}:${languageCode}${textKey}`;
                    if (r.error) {
                        adviceTranslationCacheRef.current.set(cacheKey, null);
                        return;
                    }
                    const data = r.data;
                    if (Array.isArray(data)) {
                        const match = data.find((item) => {
                            const raw = (item?.language_code || item?.language || item?.lang || '').toString().toLowerCase();
                            const selLang = (selectedLang || '').toString().toLowerCase();
                            try {
                                if (raw === languageCode) return item?.translation;
                                if (raw === selLang) return item?.translation;
                                if (getLanguageCode(raw) === languageCode) return item?.translation;
                                if (raw.startsWith(languageCode) || languageCode.startsWith(raw)) return item?.translation;
                            } catch (_) {
                            }
                            return false;
                        });
                        if (match && match.translation) {
                            translationsMap[id] = match.translation;
                            adviceTranslationCacheRef.current.set(cacheKey, match.translation);
                            try {
                                console.debug('fetched translation for id:', id, 'language=', languageCode);
                            } catch (_) {
                            }
                            try {
                                console.debug('advice translation found in localStorage by id:', id, languageCode);
                            } catch (_) {
                            }
                            try {
                                const textLower = (text || '').toString().trim().toLowerCase();
                                if (textLower) {
                                    const tkey = `text:${textLower}`;
                                    translationsMap[tkey] = match.translation;
                                    adviceTranslationCacheRef.current.set(`${tkey}:${languageCode}`, match.translation);
                                    try {
                                        console.debug('also mapping by text:', tkey, languageCode);
                                    } catch (_) {
                                    }
                                }
                            } catch (_) {
                            }
                            return;
                        }
                    }
                    adviceTranslationCacheRef.current.set(cacheKey, null);
                });

                try {
                    // Persist fetched translations to localStorage for future use
                    const raw2 = localStorage.getItem(ADVICE_TRANSLATIONS_KEY) || '{}';
                    const storage2 = JSON.parse(raw2 || '{}');
                    results.forEach((r, idx) => {
                        const id2 = r.id || (idsToFetch[idx] && idsToFetch[idx].id);
                        const text2 = (idsToFetch[idx] && idsToFetch[idx].text) || '';
                        if (!id2) return;
                        if (r.error) {
                            storage2[id2] = storage2[id2] || {
                                translations: [],
                                text: text2 || storage2[id2]?.text || null
                            };
                        } else if (Array.isArray(r.data)) {
                            storage2[id2] = {translations: r.data, text: text2 || storage2[id2]?.text || null};
                        } else {
                            storage2[id2] = storage2[id2] || {
                                translations: [],
                                text: text2 || storage2[id2]?.text || null
                            };
                        }
                    });
                    localStorage.setItem(ADVICE_TRANSLATIONS_KEY, JSON.stringify(storage2));
                } catch (_) { /* ignore localStorage failures */
                }
            } catch (e) {
                console.error('Error fetching advice translations', e);
            }

            return translationsMap;
        };

        const maybeLoad = async () => {
            try {
                const current = consultationData?.advicesData || consultationData?.advice || advicesData || [];
                const asArray = Array.isArray(current) ? current : (current ? [current] : []);
                // Build entries with { id, text }
                const entries = asArray.map((a) => {
                    if (!a) return null;
                    const id = (typeof a === 'object' ? (a.id || a.advice_id) : a) || null;
                    const text = typeof a === 'object' ? (a.advice || a.advice_text || a.text || '') : null;
                    return {id, text};
                }).filter(Boolean);

                // Include advices that may only be in the DOM (inserted by other components)
                try {
                    if (contentRootRef?.current) {
                        const els = contentRootRef.current.querySelectorAll('[data-advice-id], [data-adviceid], [data-advice]');
                        els.forEach((el) => {
                            try {
                                const attr = el.getAttribute('data-advice-id') || el.getAttribute('data-adviceid') || el.getAttribute('data-advice');
                                const id = attr ? String(attr).trim() : null;
                                const text = el.textContent ? String(el.textContent || '').trim() : null;
                                if (!id && !text) return;
                                // Avoid duplicates by id or exact text
                                const has = entries.some((e) => (e.id && String(e.id) === String(id)) || (e.text && String(e.text).trim() === String(text).trim()));
                                if (!has) entries.push({id: id || null, text: text || null});
                            } catch (_) { /* noop */
                            }
                        });
                    }
                } catch (_) { /* ignore DOM scanning errors */
                }
                if (!entries.length) {
                    setAdviceTranslations({});
                    return;
                }
                if (selectedLang === 'english') {
                    setAdviceTranslations({});
                    return;
                }
                const langCode = getLanguageCode(selectedLang);
                const map = await fetchAdviceTranslations(entries, langCode);
                setAdviceTranslations(map);
                // Apply translations to DOM nodes (for advices rendered by other components into DOM)
                try {
                    const root = contentRootRef && contentRootRef.current;
                    if (root) {
                        const nodes = root.querySelectorAll('[data-advice-id], [data-adviceid], [data-advice]');
                        nodes.forEach((el) => {
                            try {
                                const aid = el.getAttribute('data-advice-id') || el.getAttribute('data-adviceid') || el.getAttribute('data-advice');
                                const domText = (el.textContent || '').toString().trim();
                                let translated = null;
                                if (aid) {
                                    if (map[aid]) translated = map[aid];
                                    // also check runtime cache by key id:lang
                                    if (!translated) {
                                        const ck1 = `${aid}:${getLanguageCode(selectedLang)}`; // fallback
                                        if (adviceTranslationCacheRef.current.has(ck1)) translated = adviceTranslationCacheRef.current.get(ck1);
                                    }
                                }
                                if (!translated && domText) {
                                    const tkey = `text:${domText.toLowerCase()}`;
                                    if (map[tkey]) translated = map[tkey];
                                    if (!translated && adviceTranslationCacheRef.current.has(`${tkey}:${getLanguageCode(selectedLang)}`)) translated = adviceTranslationCacheRef.current.get(`${tkey}:${getLanguageCode(selectedLang)}`);
                                }
                                if (translated && String(domText).trim() !== String(translated).trim()) {
                                    try {
                                        console.debug('Applying translation to DOM node', {aid, domText, translated});
                                    } catch (_) {
                                    }
                                    el.textContent = translated;
                                    el.setAttribute('data-advice-translated', getLanguageCode(selectedLang));
                                }
                            } catch (_) {
                            }
                        });
                    }
                } catch (_) {
                }
                // Rebuild PDF with new translations
                try {
                    schedulePdfBuild(false);
                } catch (_) {
                }
            } catch {
                setAdviceTranslations({});
            }
        };

        maybeLoad();
        // Also observe DOM changes under contentRootRef for any dynamically added advices
        let domObserver = null;
        let domDebounce = null;
        try {
            const root = contentRootRef && contentRootRef.current;
            if (root && typeof MutationObserver !== 'undefined') {
                domObserver = new MutationObserver(() => {
                    if (domDebounce) clearTimeout(domDebounce);
                    domDebounce = setTimeout(() => {
                        maybeLoad().catch(() => {
                        });
                    }, 120);
                });
                domObserver.observe(root, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['data-advice-id', 'data-adviceid', 'data-advice']
                });
            }
        } catch (_) { /* ignore observer errors */
        }
        return () => {
            try {
                if (domObserver) domObserver.disconnect();
            } catch (_) {
            }
            try {
                if (domDebounce) clearTimeout(domDebounce);
            } catch (_) {
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, selectedLang, consultationData?.advicesData, consultationData?.advice, advicesData]);

    // External bulk translation for selected sections (headers + data)
    useEffect(() => {
        const run = async () => {
            try {
                if (selectedLang === 'english') {
                    setBulkTranslations({});
                    return;
                }
                // language code would be used for bulk API calls if enabled
                const toTranslate = new Set();

                // Section headers to translate (only specified sections)
                toTranslate.add('Rx');
                ['Medicine', 'Dosage', 'Duration'].forEach(h => toTranslate.add(h));
                toTranslate.add('Advice');
                toTranslate.add('Referred To');
                ;['Doctor', 'Speciality', 'Phone', 'Email', 'Hospital', 'Address'].forEach(h => toTranslate.add(h));
                toTranslate.add('Follow up');
                // Always translate headers for Investigation/Past Medications
                toTranslate.add('Investigations');
                toTranslate.add('Past Medications');
                // Common units/words
                toTranslate.add('days');
                toTranslate.add('units');

                // Medicines data
                const meds = consultationData.medicinesData || consultationData.medicines || medicinesData || [];
                meds.forEach(m => {
                    if (m?.name) toTranslate.add(String(m.name));
                    if (m?.type) toTranslate.add(String(m.type));
                    if (m?.howToTake) toTranslate.add(String(m.howToTake));
                    const times = getTimesFromFrequency(m?.frequency || '');
                    if (times.length) toTranslate.add(times.join(', '));
                    if (m?.duration) toTranslate.add(String(m.duration));
                });


                // Referred values (translate doctor/speciality/hospital/address/email; phone handled via digit localization)
                const d = consultationData || {};
                [d.referredDoctor, d.referredSpeciality, d.referredHospital, d.referredHospitalAddress, d.referredEmail].forEach(v => {
                    if (v) toTranslate.add(String(v));
                });

                // Follow up value
                const fu = consultationData.followUpDate || followUpDate || '';
                if (fu) toTranslate.add(String(fu));

                const texts = Array.from(toTranslate);
                if (!texts.length) {
                    setBulkTranslations({});
                    return;
                }

                let resultMap = {};
                // try {
                //   const resp = await axiosInstance.post('/api/translate/bulk', { texts, target: langCode });
                //   const arr = resp?.data?.data || resp?.data || [];
                //   if (Array.isArray(arr)) {
                //     arr.forEach(item => { if (item && item.source && item.translated) { resultMap[item.source] = item.translated; } });
                //   } else if (arr && typeof arr === 'object') {
                //     resultMap = arr;
                //   }
                // } catch (_) {
                //   resultMap = {};
                // }
                setBulkTranslations(resultMap);
            } catch (_) {
                setBulkTranslations({});
            }
        };

        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLang, consultationData, medicinesData, followUpDate]);

    // Data resolution logic (priority system)
    useEffect(() => {
        const getConsultationData = async () => {
            if (prescriptionData && prescriptionData.patient_id) {
                setConsultationData(prescriptionData);
                return;
            }
            const storedData = JSON.parse(localStorage.getItem('currentConsultationData') || '{}');
            if (storedData.appointment_id) {
                try {
                    // You may want to use your axios instance here
                    // const prescriptionResponse = await axiosInstance.get(`/api/prescription/getPrescriptions?appointment_id=${storedData.appointment_id}`);
                    // if (prescriptionResponse.data.success && prescriptionResponse.data.data.length > 0) {
                    //   const prescriptionData = prescriptionResponse.data.data[0];
                    //   setConsultationData({ ...storedData, ...prescriptionData });
                    //   return;
                    // }
                } catch (error) {
                    // fallback to storedData
                }
            }
            setConsultationData(storedData);
        };
        getConsultationData();
    }, [prescriptionData]);

    // useEffect(() => {
    //   if (!isOpen) {
    //     historyPollRawRef.current = null;
    //     historyPollTimestampRef.current = null;
    //     return undefined;
    //   }

    //   const pollHistory = () => {
    //     if (typeof window === 'undefined') return;
    //     const storedRaw = localStorage.getItem('currentConsultationData');
    //     if (!storedRaw) return;
    //     if (storedRaw === historyPollRawRef.current) return;

    //     let parsed;
    //     try {
    //       parsed = JSON.parse(storedRaw);
    //     } catch (error) {
    //       console.warn('preview: unable to parse consultation history', error);
    //       historyPollRawRef.current = storedRaw;
    //       return;
    //     }

    //     if (!parsed || typeof parsed !== 'object') {
    //       historyPollRawRef.current = storedRaw;
    //       return;
    //     }

    //     const timestamp = parsed.timestamp || parsed.lastUpdated;
    //     if (timestamp && timestamp === historyPollTimestampRef.current) {
    //       historyPollRawRef.current = storedRaw;
    //       return;
    //     }

    //     historyPollRawRef.current = storedRaw;
    //     if (timestamp) {
    //       historyPollTimestampRef.current = timestamp;
    //     }
    //     setConsultationData(parsed);
    //   };

    //   pollHistory();
    //   const intervalId = setInterval(pollHistory, 5000);
    //   return () => {
    //     clearInterval(intervalId);
    //     historyPollRawRef.current = null;
    //     historyPollTimestampRef.current = null;
    //   };
    // }, [isOpen, prescriptionData]);

    // Close on ESC
    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e) => {
            if (e.key === 'Escape') onClose?.();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [isOpen, onClose]);

    // Cleanup PDF blob URLs on unmount
    useEffect(() => {
        return () => {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
            }
            if (pdfPreviewUrl) {
                URL.revokeObjectURL(pdfPreviewUrl);
            }
        };
    }, [pdfUrl, pdfPreviewUrl]);


    // const getDoctorData = async () => {
    //   try {
    //     const storedDoctor = await axiosInstance.get(`api/doctor/profile?doctor_id=${doctorId}`);
    //   } catch (error) {
    //     console.error("Error fetching doctor data:", error);
    //   }
    // };
    // Load doctor data from localStorage
    // Load doctor data from localStorage
    useEffect(() => {
        if (!isOpen) return;

        async function fetchDoctor() {
            try {
                const profileRaw = localStorage.getItem('currentDoctorProfile');
                if (!profileRaw) return;

                const DoctorProfile = JSON.parse(profileRaw);
                const doctor_id = DoctorProfile?.doctor_id;
                if (!doctor_id) return;

                const existingId = doctorData?.doctor?.doctor_id || doctorData?.doctor_id;
                if (existingId && existingId === doctor_id) {
                    doctorProfileCacheRef.current = doctor_id;
                    return;
                }

                if (doctorProfileCacheRef.current === doctor_id && doctorData) {
                    return;
                }

                const response = await axiosInstance.get('api/doctor/profile', {
                    params: {doctor_id}
                });
                setDoctorData(response.data);
                doctorProfileCacheRef.current = doctor_id;
                return response.data;
            } catch (error) {
                console.log(error);
            }
        }

        fetchDoctor();

    }, [doctorData, isOpen]);

    // Automatically enable QR code display when QR code is available
    useEffect(() => {
        if (doctorData?.doctor?.qr_code || doctorData?.qr_code) {
            setPrintPreferences(prev => ({
                ...prev,
                layoutPreferences: {
                    ...prev.layoutPreferences,
                    showQRCode: true
                }
            }));
        }
    }, [doctorData]);

    const getDisplayDoctor = () => {
        // Normalize doctor/clinic fields from various shapes
        const root = doctorData || doctor || {};
        const doc = root.doctor || root;
        const clinic = root.clinic || root.clinic_details || root.clinicInfo || {};

        const fullName = (() => {
            const fromDoc =
                doc?.doctor ||
                doc?.name ||
                [doc?.firstname, doc?.lastname].filter(Boolean).join(' ') ||
                doc?.docter;
            return (fromDoc || '').toString().trim();
        })();

        const Doc_qr_code = doc?.qr_code || doc?.qrCode || '';
        const degrees =
            doc?.qualification ||
            doc?.qualifications ||
            doc?.degrees ||
            doc?.degree ||
            '';

        if (Doc_qr_code && Doc_qr_code.startsWith('http')) {
            console.log('Doctor QR Code URL:', Doc_qr_code);
        }
        const registrationNo =
            doc?.medical_license ||
            doc?.registration_number ||
            doc?.registration_no ||
            doc?.regno ||
            doc?.license_no ||
            '';

        const phone =
            doc?.whatsapp_no ||
            doc?.phoneno ||
            doc?.phone ||
            doc?.mobile ||
            clinic?.whatsapp_no ||
            clinic?.phoneno ||
            clinic?.phone ||
            '';

        const clinicName =
            clinic?.clinic_name ||
            clinic?.name ||
            doc?.clinic_name ||
            '';

        const clinic_icon = clinic?.clinic_icon || clinic?.logo || doc?.clinic_logo || '';

        if (clinic_icon && clinic_icon.startsWith('http')) {
            console.log('Clinic Icon URL:', clinic_icon);
        }
        const clinicAddress =
            clinic?.address ||
            clinic?.clinic_address ||
            doc?.clinic_address ||
            '';

        const clinicPhone =
            clinic?.phoneno ||
            clinic?.whatsapp_no ||
            clinic?.phone ||
            doc?.clinic_phone ||
            doc?.clinic_whatsapp ||
            '';
        const formatOpd = (opd) => {
            if (!opd) return '';
            let data = opd;
            if (typeof data === 'string') {
                try {
                    data = JSON.parse(data);
                } catch {
                    return String(opd);
                }
            }
            if (!data || typeof data !== 'object') return '';

            const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
            const abbr = {
                monday: 'Mon', tuesday: 'Tue', wednesday: 'Wed',
                thursday: 'Thu', friday: 'Fri', saturday: 'Sat', sunday: 'Sun'
            };

            const pad2 = (n) => String(n).padStart(2, '0');
            const isNullishTime = (v) => (
                v === null ||
                v === undefined ||
                (typeof v === 'string' && v.trim() === '') ||
                (typeof v === 'string' && v.trim().toLowerCase() === 'null')
            );

            // Accept "0900", "09:00", "9:00", "09:00 AM" variants
            const normTime = (t) => {
                if (!t) return null;
                const s = String(t).trim().toUpperCase().replace(/\s+/g, '');
                // Extract am/pm if present
                const ampm = /AM|PM/.test(s) ? (s.endsWith('AM') ? 'AM' : 'PM') : null;
                const core = ampm ? s.replace(/AM|PM/, '') : s;
                let m = /^(\d{1,2}):?(\d{2})$/.exec(core);
                if (!m) return null;
                let h = Math.min(23, Math.max(0, parseInt(m[1], 10)));
                let mm = Math.min(59, Math.max(0, parseInt(m[2], 10)));
                // If AM/PM provided, convert to 24h
                if (ampm) {
                    if (ampm === 'AM') {
                        if (h === 12) h = 0;
                    } else {
                        if (h !== 12) h += 12;
                    }
                }
                return `${pad2(h)}:${pad2(mm)}`;
            };

            const to24Range = (range) => {
                const [from, to] = String(range).split('-').map(s => s?.trim());
                const f = normTime(from);
                const t = normTime(to);
                return f && t ? `${f}-${t}` : null;
            };

            const to12 = (hhmm) => {
                const [hStr, mStr] = hhmm.split(':');
                let h = parseInt(hStr, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                h = h % 12;
                if (h === 0) h = 12;
                return `${pad2(h)}:${mStr} ${ampm}`;
            };

            // Group days by identical time ranges and track closed days
            const groups = {}; // 'HH:mm-HH:mm' -> Set(days)
            const closedDays = [];

            dayOrder.forEach((day) => {
                const v = data[day] ?? data[day.toUpperCase()] ?? data[abbr[day]];
                if (isNullishTime(v)) {
                    closedDays.push(day);
                    return;
                }
                const parts = String(v).split(',').map(s => s.trim()).filter(Boolean);
                let added = false;
                parts.forEach((p) => {
                    const key = to24Range(p);
                    if (!key) return;
                    if (!groups[key]) groups[key] = new Set();
                    groups[key].add(day);
                    added = true;
                });
                if (!added) {
                    closedDays.push(day);
                }
            });

            const entries = Object.entries(groups);
            const lines = [];

            if (entries.length) {
                // Sort by start time (ascending)
                entries.sort((a, b) => {
                    const aStart = parseInt(a[0].split('-')[0].replace(':', ''), 10);
                    const bStart = parseInt(b[0].split('-')[0].replace(':', ''), 10);
                    return aStart - bStart;
                });

                entries.forEach(([range, daysSet]) => {
                    const days = Array.from(daysSet).sort((d1, d2) => dayOrder.indexOf(d1) - dayOrder.indexOf(d2));
                    const dayStr = days.map(d => abbr[d]).join(',');
                    const [from24, to24] = range.split('-');
                    lines.push(`${dayStr}:\n ${to12(from24)} - ${to12(to24)}`);
                });
            }

            if (closedDays.length) {
                const closedStr = closedDays
                    .sort((d1, d2) => dayOrder.indexOf(d1) - dayOrder.indexOf(d2))
                    .map(d => abbr[d])
                    .join(',');
                lines.push(`${closedStr}: Close`);
            }

            // Render line-by-line in UI
            return lines.length
                ? <span style={{whiteSpace: 'pre-line'}}>{lines.join('\n')}</span>
                : '';
        };

        const clinicTimings =
            formatOpd(doc?.opd_timing) ||
            formatOpd(doc?.clinic_timings) ||
            formatOpd(clinic?.timings) ||
            '';
        // alert(clinicTimings)

        const name = fullName || '';
        return {
            name,
            degrees,
            Doc_qr_code,
            registrationNo,
            phone,
            clinicName,
            clinicAddress,
            clinic_icon,
            clinicPhone,
            clinicTimings
        };
    };

    const openDoctorModal = () => setIsDoctorModalOpen(true);
    const closeDoctorModal = () => setIsDoctorModalOpen(false);
    const handleDoctorModalSubmit = (data) => {
        setPrintPreferences(data);
        try {
            localStorage.setItem('printPreferences', JSON.stringify(data));
        } catch (_) {
        }
        closeDoctorModal();
    };

    // Helpers to normalize incoming data across formats
    const normalizeComplaints = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) {
            return raw.map((item) => {
                if (typeof item === 'string') return {label: item};
                if (item && typeof item === 'object') {
                    const parts = [item.complaint || item.name || item.text].filter(Boolean);
                    if (item.severity) parts.push(`Severity: ${item.severity}`);
                    if (item.duration) parts.push(`Duration: ${item.duration}`);
                    if (item.date) parts.push(`Date: ${item.date}`);
                    return {label: parts.join(' ') || '-'};
                }
                return {label: String(item)};
            });
        }
        return [];
    };

    const normalizeDiagnosis = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) {
            return raw.map((item) => {
                if (typeof item === 'string') return {label: item};
                if (item && typeof item === 'object') {
                    // Prefer common fields
                    const primary = item.diagnosis || item.name || item.text;
                    const parts = [primary].filter(Boolean);
                    if (item.no) parts.push(`(${item.no})`);
                    return {label: parts.join(' ') || '-'};
                }
                return {label: String(item)};
            });
        }
        return [];
    };

    const normalizeAllergies = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) return raw.filter(Boolean);
        if (typeof raw === 'object') {
            // Flatten category arrays like { medicines: [...], food: [...], other: [...] }
            return Object.values(raw).reduce((acc, val) => {
                if (Array.isArray(val)) acc.push(...val.filter(Boolean));
                return acc;
            }, []);
        }
        return [];
    };

    // Section rendering helpers
    const renderPatientDetails = () => {
        const data = consultationData;

        const id = data.patient_id || patientData?.id || 'N/A';
        const name = data.patient_name || patientData?.name || 'N/A';
        const gender = data.patient_gender || patientData?.gender || 'N/A';
        const phone = data.patient_phone || patientData?.phone || 'N/A';
        const age = (data.patient_age ?? patientData?.age) ?? 'N/A';

        const items = [id, name, gender, phone, age !== 'N/A' ? `${age} Years` : null].filter(Boolean);

        return (
            <div className="prescription-patient-bar">
                {items.map((item, index) => (
                    <span key={index} className="prescription-patient-bar__item">{item}</span>
                ))}
            </div>
        );
    };
    // Fetch Parameters by appointment and render them
    const [fetchedParams, setFetchedParams] = useState([]);
    const [paramsLoading, setParamsLoading] = useState(false);
    const [paramsFetchError, setParamsFetchError] = useState(null);
    const lastFetchedApptRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;

        // Resolve appointment id from consultationData or localStorage fallback
        let apptId = consultationData?.appointment_id;
        if (!apptId) {
            try {
                const stored = JSON.parse(localStorage.getItem('currentConsultationData') || '{}');
                apptId = stored?.appointment_id;
            } catch (_) {
            }
        }
        if (!apptId) {
            setFetchedParams([]);
            return;
        }

        if (lastFetchedApptRef.current === apptId) return; // avoid duplicate fetch
        lastFetchedApptRef.current = apptId;

        setParamsLoading(true);
        setParamsFetchError(null);

        const headers = {};
        try {
            const token = localStorage.getItem('token');
            if (token) headers['Authorization'] = token;
        } catch (_) {
        }

        axiosInstance
            .get(`/api/parameters/byAppointment?appointment_id=${apptId}`, {headers})
            .then((res) => {
                const data = res?.data?.data ?? res?.data ?? [];
                setFetchedParams(Array.isArray(data) ? data : []);
            })
            .catch((err) => {
                setParamsFetchError(err?.message || 'Failed to load parameters');
                setFetchedParams([]);
            })
            .finally(() => setParamsLoading(false));
    }, [isOpen, consultationData?.appointment_id]);

    const renderParameters = () => {
        // Prefer API-fetched params; fallback to props/state if API empty
        const params = (Array.isArray(fetchedParams) && fetchedParams.length
                ? fetchedParams
                : Array.isArray(consultationData.parameters)
                    ? consultationData.parameters
                    : Array.isArray(parametersData)
                        ? parametersData
                        : []
        ).filter(Boolean);

        if (paramsLoading) {
            return (
                <section className="prescription-section">
                    <h3 className="prescription-section__title">Parameters:</h3>
                    <div className="prescription-section__content">Loading parameters...</div>
                </section>
            );
        }

        if (paramsFetchError && !params.length) {
            return (
                <section className="prescription-section">
                    <h3 className="prescription-section__title">Parameters:</h3>
                    <div className="prescription-section__content prescription-section__error">Failed to load
                        parameters
                    </div>
                </section>
            );
        }

        if (!params.length) return null;

        // ----- SHARED HELPERS -----
        const normalize = (s = "") => String(s || "").trim();
        const fmtValue = (item) => {
            const v = item?.value ?? "";
            const u = item?.unit ? ` ${item.unit}` : "";
            return `${v}${u}`;
        };
        const tokensFor = (name) =>
            normalize(name)
                .replace(/\s+/g, " ")
                .split(/[\s/,-]+/)
                .filter(Boolean);
        const escapeRegex = (s) => s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");

        const renderCompactGroup = (title, items) => {
            if (!items || !items.length) return null;
            return (
                <div
                    key={title}
                    className="prescription-params__group prescription-params__group--compact"
                    style={{marginBottom: "4px"}}
                >
                    {title && (
                        <span
                            className="prescription-params__group-title"
                            style={{display: "inline", marginRight: "8px"}}
                        >
              {title}:
            </span>
                    )}
                    <div
                        className="prescription-params__compact-list"
                        style={{display: "inline-flex", flexWrap: "wrap", gap: "4px 12px"}}
                    >
                        {items.map((it, idx) => (
                            <div
                                key={idx}
                                className="prescription-params__compact-item"
                                style={{
                                    display: "inline-flex",
                                    alignItems: "baseline",
                                    fontSize: "11px",
                                }}
                            >
                <span
                    className="prescription-params__compact-label"
                    style={{fontWeight: "600", marginRight: "4px"}}
                >
                  {it.label}:
                </span>
                                <span className="prescription-params__compact-value">
                  {it.value || "-"}
                </span>
                                {idx < items.length - 1 && (
                                    <span
                                        className="prescription-params__compact-separator"
                                        style={{marginLeft: "8px", color: "#ccc"}}
                                    >
                    |
                  </span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            );
        };

        const eyeReg = /(^|\s|[^a-z])(right|re|od|r(?![a-z])|left|le|os|l(?![a-z]))($|\s|[^a-z])/i;
        const allItemsMerged = [];

        if (params.some((p) => String(p.name || "").toLowerCase().includes("eye"))) {
            // Eye Branch
            const remaining = new Set(params.map((_, i) => i));
            const groups = [];
            const maxTokenLen = 2;
            const minGroupSize = 2;

            const buildCandidates = () => {
                const prefixMap = new Map();
                const suffixMap = new Map();
                remaining.forEach((idx) => {
                    const name = normalize(params[idx].name || params[idx].parameter_name || params[idx].label || "");
                    const tokens = tokensFor(name);
                    const limit = Math.min(maxTokenLen, tokens.length);
                    for (let len = 1; len <= limit; len++) {
                        const pref = tokens.slice(0, len).join(" ").toLowerCase();
                        const suff = tokens.slice(-len).join(" ").toLowerCase();
                        if (pref) {
                            const set = prefixMap.get(pref) || new Set();
                            set.add(idx);
                            prefixMap.set(pref, set);
                        }
                        if (suff) {
                            const set = suffixMap.get(suff) || new Set();
                            set.add(idx);
                            suffixMap.set(suff, set);
                        }
                    }
                });
                const toArr = (map) => Array.from(map.entries()).map(([text, set]) => ({
                    text,
                    indices: Array.from(set),
                    count: set.size,
                    len: text.split(' ').length
                }));
                return {
                    prefixes: toArr(prefixMap).filter(c => c.count >= minGroupSize),
                    suffixes: toArr(suffixMap).filter(c => c.count >= minGroupSize)
                };
            };

            while (remaining.size > 0) {
                const {prefixes, suffixes} = buildCandidates();
                const candidates = [...prefixes.map(c => ({...c, type: 'prefix'})), ...suffixes.map(c => ({
                    ...c,
                    type: 'suffix'
                }))];
                if (!candidates.length) break;
                candidates.sort((a, b) => (b.count - a.count) || (b.len - a.len) || (a.type === 'suffix' ? -1 : 1));
                const best = candidates[0];
                if (!best || best.count < minGroupSize) break;
                const matched = [];
                best.indices.forEach((idx) => {
                    if (!remaining.has(idx)) return;
                    const rawName = normalize(params[idx].name || params[idx].parameter_name || params[idx].label || "");
                    let label = rawName;
                    if (best.type === "suffix") {
                        const rx = new RegExp(`\\s*${escapeRegex(best.text)}\\s*$`, "i");
                        label = rawName.replace(rx, "").trim();
                        if (!label) label = best.text;
                    } else {
                        const rx = new RegExp(`^\\s*${escapeRegex(best.text)}\\s*`, "i");
                        label = rawName.replace(rx, "").trim();
                        if (!label) label = best.text;
                    }
                    matched.push({label, value: fmtValue(params[idx]), original: params[idx]});
                    remaining.delete(idx);
                });
                const title = best.text.split(" ").map((w) => w.length <= 3 ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
                groups.push({title, items: matched});
            }

            // Separate Eye groups from others
            const eyeGroups = [];
            const otherItems = [];

            // Derive leftovers from remaining indices safely
            const leftovers = [];
            if (remaining && remaining.size > 0) {
                remaining.forEach((idx) => {
                    const p = params[idx];
                    if (p) {
                        const rawName = normalize(p.name || p.parameter_name || p.label || "");
                        const val = fmtValue(p);
                        // Only add if it has a meaningful value
                        if (val && val !== '-' && val !== '') {
                            leftovers.push({
                                label: rawName,
                                value: val,
                                original: p
                            });
                        }
                    }
                });
            }

            // Helper to check if a group is "Right Eye" or "Left Eye"
            const isRightEye = (t) => /(^|\s|[^a-z])(right|re|od|r(?![a-z]))($|\s|[^a-z])/i.test(t);
            const isLeftEye = (t) => /(^|\s|[^a-z])(left|le|os|l(?![a-z]))($|\s|[^a-z])/i.test(t);

            if (params.some((p) => String(p.name || "").toLowerCase().includes("eye"))) {
                groups.forEach(g => {
                    if (isRightEye(g.title) || isLeftEye(g.title)) {
                        eyeGroups.push(g);
                    } else {
                        // Flatten others into a single list
                        g.items.forEach(it => {
                            let label = it.label;
                            if (g.title && g.title !== "General" && g.title !== "Other") {
                                label = `${g.title} ${label}`;
                            }
                            otherItems.push({...it, label});
                        });
                    }
                });

                // Add leftovers to otherItems
                leftovers.forEach(it => otherItems.push(it));

            } else {
                // Fallback for non-eye logic: treat everything as 'otherItems'
                groups.forEach(g => {
                    g.items.forEach(it => {
                        let label = it.label;
                        if (g.title && g.title !== "General" && g.title !== "Other") {
                            label = `${g.title} ${label}`;
                        }
                        otherItems.push({...it, label});
                    });
                });
                leftovers.forEach(it => otherItems.push(it));
            }

            // Sort Eye Groups: Left then Right or Right then Left?
            // Image 1 shows: "Left EYE" top, "Right EYE" bottom.
            // Image 2 shows: "Right EYE" top, but task says "parameters Right First then Left eye".
            // I will Sort Right then Left as per Task.txt "parameters Right First then Left eye DONE".
            eyeGroups.sort((a, b) => {
                if (isRightEye(a.title) && !isRightEye(b.title)) return -1;
                if (!isRightEye(a.title) && isRightEye(b.title)) return 1;
                return 0;
            });

            // Render helper for Eye Table
            const renderEyeTable = (group) => {
                // We want specific columns if possible, or just render what we have.
                // The image shows: UCVA | IOP | SPH | CYL | AXIS | BCVA | (Near Vision) SPH
                // We can try to map these if the items match, otherwise we just dump them in cells.
                // Let's assume the items order in the group is roughly correct or we just render them in order.
                return (
                    <div key={group.title} style={{marginBottom: '12px'}}>
                        <div className="prescription-parameters__group-title">{group.title}:</div>
                        <table className="prescription-eye-table">
                            <thead>
                            <tr>
                                {group.items.map((it, idx) => (
                                    <th key={idx}>{it.label}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                {group.items.map((it, idx) => (
                                    <td key={idx}>{it.value || '-'}</td>
                                ))}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                );
            };

            return (
                <section className="prescription-section">
                    <h3 className="prescription-section__title">Parameters:</h3>
                    <div className="prescription-section__content">
                        {/* Render Eye Groups individually as tables */}
                        {eyeGroups.map(g => renderEyeTable(g))}

                        {/* Render everything else as one compact group */}
                        {otherItems.length > 0 && renderCompactGroup("", otherItems)}
                    </div>
                </section>
            );
        } else {
            // Non-eye parameters: simple flat list
            const allItems = [];
            params.forEach((p) => {
                const rawName = normalize(p.name || p.parameter_name || p.label || "");
                const val = fmtValue(p);
                if (val && val !== '-' && val !== '') {
                    allItems.push({label: rawName, value: val, original: p});
                }
            });

            if (!allItems.length) return null;

            return (
                <section className="prescription-section">
                    <h3 className="prescription-section__title">Parameters:</h3>
                    <div className="prescription-section__content">
                        {renderCompactGroup("", allItems)}
                    </div>
                </section>
            );
        }
    };

    const renderAllergies = () => {
        const raw = consultationData.allergies || consultationData.allergiesData || allergiesData || [];
        const asArray = normalizeAllergies(raw);
        if ((Array.isArray(raw) && !asArray.length) || (!raw || (typeof raw === 'object' && !Object.keys(raw).length))) return null;
        const renderGrouped = typeof raw === 'object' && !Array.isArray(raw);
        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">{trHeader('allergies', 'Allergies')}:</h3>
                <div className="prescription-section__content prescription-allergies">
                    {renderGrouped ? (
                        <>
                            {raw.medicines?.length > 0 && (
                                <div className="prescription-allergies__category">
                                    <span className="prescription-allergies__category-label">Medicines:</span>
                                    <span>{raw.medicines.join(', ')}</span>
                                </div>
                            )}
                            {raw.food?.length > 0 && (
                                <div className="prescription-allergies__category">
                                    <span className="prescription-allergies__category-label">Food:</span>
                                    <span>{raw.food.join(', ')}</span>
                                </div>
                            )}
                            {raw.other?.length > 0 && (
                                <div className="prescription-allergies__category">
                                    <span className="prescription-allergies__category-label">Others:</span>
                                    <span>{raw.other.join(', ')}</span>
                                </div>
                            )}
                        </>
                    ) : (
                        <span>{asArray.join(', ')}</span>
                    )}
                </div>
            </section>
        );
    };

    const renderClinicalFindings = () => {
        const raw = consultationData.clinicalFindingsData || [];
        const list = Array.isArray(raw) ? raw : [];
        if (!list.length) return null;
        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">{trHeader('clinical_findings', 'Clinical Findings')}:</h3>
                <div className="prescription-section__content">
                    <div className="prescription-grid-layout">
                        {list.map((item, i) => {
                            const text = typeof item === 'string'
                                ? item
                                : item?.finding || item?.text || item?.value || '';
                            if (!text) return null;
                            return (
                                <div key={i} className="prescription-grid-card">
                                    <span>{text}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        );
    };

    const renderPastHistory = () => {
        const raw = consultationData.PastHistoryData || consultationData.PastHistory || [];
        const list = Array.isArray(raw) ? raw : [];
        if (!list.length) return null;
        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">{trHeader('past_history', 'Past History')}:</h3>
                <div className="prescription-section__content">
                    <div className="prescription-grid-layout">
                        {list.map((item, i) => {
                            const text = typeof item === 'string'
                                ? item
                                : item?.pasthistory || item?.history || item?.text || '';
                            if (!text) return null;
                            const metaParts = [];
                            if (item?.severity) metaParts.push(item.severity);
                            if (item?.duration) metaParts.push(item.duration);
                            if (item?.date) metaParts.push(item.date);
                            const meta = metaParts.length ? ` (${metaParts.join(' | ')})` : '';
                            return (
                                <div key={i} className="prescription-grid-card">
                                    <span>{text}{meta}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        );
    };


    // Render Chief Complaints separately
    const renderComplaints = () => {
        const showComplaints = printPreferences?.layoutPreferences?.showComplaints !== false;
        if (!showComplaints) return null;

        const complaintsList = normalizeComplaints(consultationData.complaints || complaints || []);
        if (!complaintsList.length) return null;

        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">Chief Complaints:</h3>
                <div className="prescription-section__content">
                    <ul className="">
                        {complaintsList.map((c, i) => <li key={i}>{c.label}</li>)}
                    </ul>
                </div>
            </section>
        );
    };

    // Render Diagnosis separately
    const renderDiagnosis = () => {
        const showDiagnosis = printPreferences?.layoutPreferences?.showDiagnosis !== false;
        if (!showDiagnosis) return null;

        const diagnosisList = normalizeDiagnosis(consultationData.diagnosis || diagnosis || []);
        if (!diagnosisList.length) return null;

        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">{trHeader('diagnosis', 'Diagnosis')}:</h3>
                <div className="prescription-section__content">
                    <ul className="prescription-list">
                        {diagnosisList.map((d, i) => <li key={i}>{d.label}</li>)}
                    </ul>
                </div>
            </section>
        );
    };

    const getTimesFromFrequency = (freq = '') => {
        // Supports two formats:
        // 1) 4-char pattern with '|' meaning take and '0' meaning skip. Example: '|0||'
        // 2) Text-based list of times. Example: 'Morning, Evening, Night'
        const slots = ['Morning', 'Afternoon', 'Evening', 'Night'];
        const f = String(freq).trim();
        const res = [];
        if (!f) return res;

        // Pattern mode
        const looksLikePattern = /[|0]/.test(f) && f.length >= 3 && f.length <= 6;
        if (looksLikePattern) {
            for (let i = 0; i < Math.min(4, f.length); i++) {
                if (f[i] === '|') res.push(slots[i]);
            }
            return res;
        }

        // Text mode
        const lower = f.toLowerCase();
        // If the value is a known abbreviation or code, map to a localized-friendly phrase
        const normalized = lower.replace(/\s+/g, '');
        const codeMap = {
            od: 'OD (Once a day)',
            bd: 'BD (Twice a day)',
            tid: 'TID (Three times a day)',
            qid: 'QID (Four times a day)',
            hs: 'HS (Once at night)',
            '1hrly': '1 Hrly (Every hour)',
            '1hr': '1 Hrly (Every hour)',
            '2hrly': '2 Hrly (Every 2 hours)',
            '2hr': '2 Hrly (Every 2 hours)',
            halfhrly: 'Half Hrly (Every 30 minutes)',
            'halfhr': 'Half Hrly (Every 30 minutes)'
        };
        if (codeMap[normalized]) return [codeMap[normalized]];

        // Simple slot times like Morning/Evening/Night
        slots.forEach((s) => {
            if (lower.includes(s.toLowerCase())) res.push(s);
        });
        // If comma separated but different casing/abbr, fallback to splitting
        if (!res.length && /[,\s]/.test(f)) {
            const parts = f.split(/[,\s]+/).map(p => p.trim().toLowerCase()).filter(Boolean);
            const map = {
                m: 'Morning',
                morning: 'Morning',
                a: 'Afternoon',
                afternoon: 'Afternoon',
                e: 'Evening',
                evening: 'Evening',
                n: 'Night',
                night: 'Night'
            };
            parts.forEach(p => {
                if (map[p] && !res.includes(map[p])) res.push(map[p]);
            });
        }
        // If still empty, support hourly-like patterns such as '2Hrly', '2/hrly', 'every 2 hours'
        if (!res.length) {
            // match `N hr` or `Nhrly` or `N Hrly` or `every N hour(s)`
            const hrMatch = f.match(/(\d+)\s*(hr|hrly|hours|hour)/i) || f.match(/every\s*(\d+)\s*(hr|hour|hours)/i);
            if (hrMatch) {
                const val = parseInt(hrMatch[1], 10) || 1;
                // Use the English friendly string that matches our translation file keys
                const key = `${val} Hrly (Every ${val} ${val === 1 ? 'hour' : 'hours'})`;
                return [key];
            }

            // half hourly
            if (/half\s*hr|halfhr|half-hr|halfhourly/i.test(f)) {
                return ['Half Hrly (Every 30 minutes)'];
            }

            // fallback: treat single token (some words or abbreviations) as a token for display/translation
            const tokenCandidate = f.split(/[,;|]/)[0].trim();
            if (tokenCandidate) return [tokenCandidate];
        }
        return res;
    };

    // Determine numeric frequency/day based on tokens or codes
    const frequencyCount = (freq = '') => {
        const f = String(freq || '').trim();
        if (!f) return 1;
        const normalized = f.toLowerCase().replace(/\s+/g, '');
        // Known abbreviation to count
        const codeToCount = {
            od: 1,
            bd: 2,
            tid: 3,
            qid: 4,
            'hs': 1
        };
        if (codeToCount[normalized] !== undefined) return codeToCount[normalized];

        // Match hourly patterns
        const hrMatch = f.match(/(\d+)\s*(hr|hrly|hours|hour)/i) || f.match(/every\s*(\d+)\s*(hr|hour|hours)/i);
        if (hrMatch) {
            const val = parseInt(hrMatch[1], 10) || 1;
            return Math.max(1, Math.round(24 / val));
        }
        // half hourly
        if (/half\s*hr|halfhr|half-hr|halfhourly/i.test(f)) return 48;

        // Pattern mode using | and 0
        if (/[|0]/.test(f) && f.length >= 3 && f.length <= 6) {
            return (f.match(/\|/g) || []).length || 1;
        }

        // Default: try parsing tokens returned by getTimesFromFrequency
        const tokens = getTimesFromFrequency(f);
        if (tokens && tokens.length > 0) return tokens.length;
        return 1;
    };

    // const frequencyCount = (freq = '') => getTimesFromFrequency(freq).length || 1;

    const parseDurationToDays = (d = '') => {
        const s = String(d).toLowerCase().trim();
        const num = parseFloat(s.replace(/[^0-9.]/g, '')) || 0;
        if (s.includes('day')) return Math.round(num);
        if (s.includes('week')) return Math.round(num * 7);
        if (s.includes('month')) return Math.round(num * 30);
        if (s.includes('year')) return Math.round(num * 365);
        return Math.round(num) || 0;
    };

    const totalUnits = (m) => {
        const dose = parseFloat(m?.dosage) || 1;
        const perDay = frequencyCount(m?.frequency);
        const days = parseDurationToDays(m?.duration);
        const total = Math.round(dose * perDay * days);
        return {total, days};
    };

    const renderMedicines = () => {
        const medicines = consultationData.medicinesData || consultationData.medicines || medicinesData || [];
        if (!medicines.length) return null;
        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">{trHeader('medicines', 'Medicines')}</h3>
                <div className="prescription-section__content">
                    <table className="prescription-medicines">
                        <thead>
                        <tr>
                            <th>{trHeader('medicine', 'Medicine')}</th>
                            <th>{trHeader('dosage', 'Dosage')}</th>
                            <th>{trHeader('duration', 'Duration')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {medicines.map((m, i) => {
                            const times = getTimesFromFrequency(m.frequency);
                            const {total, days} = totalUnits(m);
                            const timesJoined = times.length ? times.join(', ') : '';

                            // Enhanced frequency translation using both medicine translations and utils
                            let translatedTimes = '';
                            if (timesJoined) {
                                // First try medicine translations for exact matches
                                let exactMatch = translateMedicineTerm(timesJoined, selectedLang);
                                if (exactMatch !== timesJoined) {
                                    translatedTimes = exactMatch;
                                } else {
                                    // Try space-separated version for comma patterns
                                    const spaceSeparated = timesJoined.replace(/,\s*/g, ' ').trim();
                                    exactMatch = translateMedicineTerm(spaceSeparated, selectedLang);
                                    if (exactMatch !== spaceSeparated) {
                                        translatedTimes = exactMatch;
                                    } else {
                                        // Fallback to translating individual times using utils
                                        translatedTimes = times.map(time =>
                                            translateMedicineTerm(time, selectedLang) || tctx.translateFrequency(time) || time
                                        ).join(', ');
                                    }
                                }
                            }
                            const timesStr = translatedTimes ? `(${translatedTimes})` : '';

                            // Enhanced type translation
                            const typeSrc = m?.type ? String(m.type) : '';
                            let typeLabel = '';
                            if (typeSrc) {
                                typeLabel = translateMedicineTerm(typeSrc, selectedLang);
                                if (typeLabel === typeSrc) {
                                    // Handle compound types like "Syrup(ml)"
                                    if (typeSrc.includes('(') && typeSrc.includes(')')) {
                                        const mainType = typeSrc.split('(')[0].trim();
                                        const unit = typeSrc.match(/\(([^)]+)\)/)?.[1] || '';
                                        const translatedMainType = translateMedicineTerm(mainType, selectedLang) || mainType;
                                        const translatedUnit = translateMedicineTerm(unit, selectedLang) || unit;
                                        typeLabel = unit ? `${translatedMainType}(${translatedUnit})` : translatedMainType;
                                    } else {
                                        typeLabel = typeSrc;
                                    }
                                }
                            }

                            // Enhanced instructions translation
                            const instrSrc = m.howToTake ? String(m.howToTake) : '';
                            let instr = '';
                            if (instrSrc) {
                                instr = translateMedicineTerm(instrSrc, selectedLang);
                                if (instr === instrSrc) {
                                    // Try common variations
                                    const variations = [
                                        {from: 'After meals', to: 'after food'},
                                        {from: 'Before meals', to: 'before food'},
                                        {from: 'with milk', to: 'with milk'} // Keep as is for now
                                    ];

                                    let found = false;
                                    for (const variation of variations) {
                                        if (instrSrc.toLowerCase().includes(variation.from.toLowerCase())) {
                                            const translated = translateMedicineTerm(variation.to, selectedLang);
                                            if (translated !== variation.to) {
                                                instr = instrSrc.replace(new RegExp(variation.from, 'gi'), translated);
                                                found = true;
                                                break;
                                            }
                                        }
                                    }

                                    if (!found) {
                                        instr = tctx.translateInstructions(instrSrc) || instrSrc;
                                    }
                                }
                            }

                            // Medicine name - keep existing logic as names might not be in the translations
                            const nameSrc = m?.name ? String(m.name) : '-';
                            const nameOut = bulkTranslations[nameSrc] || nameSrc;

                            // Enhanced duration translation
                            const durationSrc = m.duration ? String(m.duration) : '';
                            let translatedDuration = '';
                            if (durationSrc) {
                                translatedDuration = translateMedicineTerm(durationSrc, selectedLang);
                                if (translatedDuration === durationSrc) {
                                    translatedDuration = tctx.translateDuration(durationSrc) || durationSrc;
                                }
                            }

                            return (
                                <tr key={i}>
                                    <td style={{border: '1px solid #666', padding: '8px 10px', verticalAlign: 'top'}}>
                                        {`${localizeDigits(i + 1, selectedLang)}. ${nameOut}`}
                                    </td>
                                    <td style={{border: '1px solid #666', padding: '8px 10px', verticalAlign: 'top'}}>
                                        <div>
                                            {`${localizeDigits(m.dosage || '-', selectedLang)} ${typeLabel}`.trim()} {timesStr}
                                        </div>
                                        {instr && <div className="text-sm text-gray-700">{instr}</div>}
                                    </td>
                                    <td style={{border: '1px solid #666', padding: '8px 10px', verticalAlign: 'top'}}>
                                        <div>
                                            {days ?
                                                `${localizeDigits(days, selectedLang)} ${translateMedicineTerm(`${days} days`, selectedLang) !== `${days} days`
                                                    ? translateMedicineTerm(`${days} days`, selectedLang).split(' ').slice(1).join(' ')
                                                    : (translateMedicineTerm('days', selectedLang) || tctx.labels.days || 'days')
                                                }` :
                                                (translatedDuration || '-')
                                            }
                                        </div>
                                        {total > 0 && (
                                            <span className="prescription-medicines__duration-units">
                          ({localizeDigits(total, selectedLang)} {translateMedicineTerm('units', selectedLang) || tctx.labels.units || 'units'})
                        </span>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </section>
        );
    };

    const renderAdvices = () => {
        const raw = consultationData.advicesData || consultationData.advice || advicesData || [];
        const list = Array.isArray(raw) ? raw : (raw ? [raw] : []);
        if (!list.length) return null;

        const pickAdviceText = (item) => {
            if (typeof item === 'string') {
                const textStr = String(item || '').trim();
                if (!textStr) return textStr;
                // Try to resolve by local storage text translation first
                try {
                    const tkey = `text:${textStr.toString().trim().toLowerCase()}`;
                    if (adviceTranslations && adviceTranslations[tkey]) return adviceTranslations[tkey];
                } catch (_) { /* noop */
                }
                // fallback to local advs JSON or instruction translate
                try {
                    const row = Array.isArray(advsLocalTranslations) ? advsLocalTranslations.find(r => r['Advice (English)'] === textStr) : null;
                    if (row && row[getAdvsLangName(selectedLang)]) return row[getAdvsLangName(selectedLang)];
                } catch (_) { /* noop */
                }
                return tctx.translateInstructions(textStr);
            }
            if (!item || typeof item !== 'object') return String(item || '');
            const viaApi = (item && item.id) ? adviceTranslations[item.id] : null;
            const baseText = (item && (item.advice || item.details || item.text)) ? String(item.advice || item.details || item.text || '') : '';
            const baseNorm = baseText.trim();
            if (viaApi) {
                try {
                    console.debug('advice translation used (id):', item.id, selectedLang);
                } catch (_) {
                }
                return viaApi;
            }
            try {
                const tr = item.translations;
                if (tr) {
                    // persist translations we received on the advice object into localStorage cache
                    try {
                        persistAdviceTranslation(item && item.id ? item.id : null, baseText, tr);
                    } catch (_) {
                    }

                    if (Array.isArray(tr)) {
                        const hit = tr.find((t) => {
                            const raw = (t?.language || t?.language_code || t?.lang || '').toString().toLowerCase();
                            const sel = (selectedLang || '').toString().toLowerCase();
                            try {
                                if (raw === sel) return true;
                                if (raw === getLanguageCode(sel)) return true;
                                if (getLanguageCode(raw) === getLanguageCode(sel)) return true;
                                if (raw.startsWith(getLanguageCode(sel)) || getLanguageCode(sel).startsWith(raw)) return true;
                            } catch (_) {
                            }
                            return false;
                        });
                        if (hit?.text) return hit.text;
                    } else if (typeof tr === 'object') {
                        if (tr[selectedLang]) return tr[selectedLang];
                    }
                }
            } catch (_) { /* noop */
            }
            const base = baseText || '';
            // fallback: check runtime cache by exact English text key
            try {
                if (!viaApi && baseNorm) {
                    const tkey = `text:${baseNorm.toString().trim().toLowerCase()}`;
                    if (adviceTranslations && adviceTranslations[tkey]) {
                        try {
                            console.debug('advice translation used (text):', tkey, selectedLang);
                        } catch (_) {
                        }
                        return adviceTranslations[tkey];
                    }
                }
            } catch (_) { /* noop */
            }
            return base ? tctx.translateInstructions(base) : '';
        };
        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">{trHeader('advice', 'Advice')}:</h3>
                <div className="prescription-section__content">
                    <ul className="prescription-list">
                        {list.map((a, i) => {
                            let text = pickAdviceText(a);
                            if (text) {
                                try {
                                    const langName = getAdvsLangName(selectedLang);
                                    const row = Array.isArray(advsLocalTranslations) ? advsLocalTranslations.find(r => r['Advice (English)'] === text) : null;
                                    if (row && row[langName]) text = row[langName];
                                } catch (_) { /* noop */
                                }
                                text = localizeDigits(text, selectedLang);
                            }
                            if (!text) return null;
                            return <li key={i}>{text}</li>;
                        })}
                    </ul>
                </div>
            </section>
        );
    };

    const renderInvestigations = () => {
        const raw = consultationData.investigationsList || consultationData.investigations || [];
        const items = Array.isArray(raw) ? raw : (raw ? [raw] : []);
        const list = items.filter(Boolean);
        if (!list.length) return null;
        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">Investigations</h3>
                <div className="prescription-section__content">
                    <ul className="prescription-list">
                        {list.map((it, idx) => {
                            const s = String(it);
                            const out =  s;
                            return <li key={idx}>{out}</li>;
                        })}
                    </ul>
                </div>
            </section>
        );
    };

    const renderPastMedications = () => {
        const raw = consultationData.pastMedication || consultationData.pastMedications || '';
        const list = Array.isArray(raw) ? raw.filter(Boolean) : (raw ? [raw] : []);
        if (!list.length) return null;
        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">Past Medications:</h3>
                <div className="prescription-section__content">
                    <ul className="prescription-list">
                        {list.map((it, idx) => {
                            const s = String(it);
                            const out = s;
                            return <li key={idx}>{out}</li>;
                        })}
                    </ul>
                </div>
            </section>
        );
    };

    const renderReferral = () => {
        const d = consultationData || {};
        const fields = [
            ['Doctor', d.referredDoctor],
            ['Speciality', d.referredSpeciality],
            ['Phone', d.referredPhone],
            ['Email', d.referredEmail],
            ['Hospital', d.referredHospital],
            ['Address', d.referredHospitalAddress],
        ].filter(([, v]) => v && String(v).trim().length > 0);
        if (!fields.length) return null;
        return (
            <section className="prescription-section">
                <h3 className="prescription-section__title">Referred To:</h3>
                <div className="prescription-section__content">
                    <div className="prescription-referral">
                        {fields.map(([label, value], idx) => {
                            const lbl = bulkTranslations[label] || label;
                            const val = (bulkTranslations[String(value)] || String(value));
                            return <div key={idx} className="prescription-referral__item"><span
                                className="prescription-referral__label">{lbl}:</span> {val}</div>;
                        })}
                    </div>
                </div>
            </section>
        );
    };

    if (!isOpen) return null;

    const contentMargins = printPreferences?.margins || {top: 20, right: 20, bottom: 20, left: 20};
    const contentStyle = {
        paddingTop: `${contentMargins.top}px`,
        paddingRight: `${contentMargins.right}px`,
        paddingBottom: `${contentMargins.bottom}px`,
        paddingLeft: `${contentMargins.left}px`,
    };


    const followUp = consultationData.followUpDate || followUpDate;
    if (!followUp) return null;


    return createPortal(
        <div
            className={`preview-wysiwyg-modal fixed inset-0 ${isDoctorModalOpen ? 'z-[1200]' : 'z-[1300]'} bg-black/60 flex items-center justify-center`}
            onClick={(e) => {
                // Only close when the backdrop itself is clicked; ignore child clicks (e.g., DoctorModal toggles)
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
            role="dialog"
            aria-modal="true"
        >

            <div
                className="preview-wysiwyg-content relative bg-white rounded-lg shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-auto"
                onClick={(e) => e.stopPropagation()}
                style={contentStyle}
            >


                <div className="prescription-toolbar">
                    <Select
                        varient="solid"
                        value={selectedLang}
                        onChange={(e) => setSelectedLang(e.target.value)}
                        isDisabled={isBuildingPdf}
                        className="prescription-toolbar__select"
                    >
                        {Object.keys(translations || {english: {}}).map((langKey) => (
                            <option key={langKey} value={langKey}>{langKey}</option>
                        ))}
                    </Select>
                    {/* Print PDF Button */}
                    <Button
                        colorScheme="green"
                        size="sm"
                        // type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handlePdfPrint();
                        }}
                        // isLoading={isBuildingPdf}
                        isDisabled={isBuildingPdf}
                        loadingText="Generating..."
                        className="prescription-toolbar__btn"
                    >
                        {isBuildingPdf ? 'Generating...' : 'Print Prescription'}
                    </Button> {/* PDF Download Button */}
                    <Button
                        colorScheme="red"
                        size="sm"
                        // type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handlePdfDownload();
                        }}
                        // isLoading={isBuildingPdf}
                        isDisabled={isBuildingPdf}
                        loadingText="Generating..."
                        className="prescription-toolbar__btn"
                    >
                        {isBuildingPdf ? 'Generating...' : 'Download Prescription'}
                    </Button>
                    {/* Save Prescription */}
                    <Button
                        colorScheme="blue"
                        size="sm"
                        // type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleSavePrescription();
                        }}
                        isDisabled={isBuildingPdf}
                        className="prescription-toolbar__btn"
                    >
                        Save Prescription
                    </Button>


                    {/* Print Preferences Button */}
                    <Button
                        colorScheme="orange"
                        size="sm"
                        // type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openDoctorModal();
                        }}
                        isDisabled={isBuildingPdf}
                        className="prescription-toolbar__btn"
                    >
                        Print Preferences
                    </Button>

                    {/* Close Button */}
                    <Button
                        // type="button"
                        className="prescription-toolbar__close"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onClose();
                        }}
                        aria-label="Close preview"
                        disabled={isBuildingPdf}
                    >
                        Close ✕
                    </Button>
                    {/* Language Dropdown */}
                </div>

                <div ref={contentRootRef} className="prescription-layout">
                    <style>
                        {`
            /* ============================================
               CSS VARIABLES & RESET
               ============================================ */
            :root {
              --prescription-page-width: 210mm;
              --prescription-page-min-height: 297mm;
              --prescription-margin-top: 5mm;
              --prescription-margin-right: 5mm;
              --prescription-margin-bottom: 5mm;
              --prescription-margin-left: 5mm;
              --prescription-section-gap: 4px; /* Reduced gap */
              --prescription-inner-padding: 2px;
              
              --prescription-font-family: 'Arial', 'Helvetica Neue', Helvetica, sans-serif;
              --prescription-font-size-base: 12px; /* Increased font */
               --prescription-font-size-header: 14px; /* Increased font */
              --prescription-font-size-sm: 13px;
              --prescription-font-size-xs: 11px;
              --prescription-font-size-lg: 15px;
              --prescription-font-size-xl: 18px;
              
              --prescription-text-color: #000000;
              --prescription-text-muted: #333333;
              --prescription-border-color: #666666; /* Lighter gray instead of black */
              --prescription-border-light: #cccccc;
              --prescription-bg-white: #ffffff;
            }

            .prescription-layout {
              color: var(--prescription-text-color) !important;
              font-family: var(--prescription-font-family) !important;
              font-size: var(--prescription-font-size-base);
              line-height: 1.2;
              width: 100%;
              max-width: var(--prescription-page-width);
              min-height: var(--prescription-page-min-height);
              margin: 0 auto;
              padding: var(--prescription-margin-top) var(--prescription-margin-right) var(--prescription-margin-bottom) var(--prescription-margin-left);
              background-color: var(--prescription-bg-white);
              box-sizing: border-box;
            }

            .prescription-layout * {
              box-sizing: border-box;
              color: var(--prescription-text-color) !important;
            }

            .prescription-toolbar{
            // one select with fixed width and buttons aligned right
              position: sticky;
              top: 0;
              background-color: #f9f9f9;
              padding: 8px 12px;
              border-bottom: 1px solid #ddd;
              display: grid;
              grid-template-columns: 1fr auto auto auto auto auto;
              align-items: center;
              gap: 8px;
              z-index: 1000;
            }

            /* HIDE TOOLBAR IN PRINT */
            @media print {
               .prescription-toolbar { display: none !important; }
            }

            /* ============================================
               HEADER - 3 COLUMN LAYOUT
               ============================================ */
            .prescription-header {
              display: grid;
              // grid-template-rows: ;
              // gap: 12px;
              // align-items: flex-start;
              // padding-bottom: 12px; /* Add padding to ensure border is visible */
              // margin-bottom: 50px;
            }

            .prescription-header-content{
            display: grid;
            grid-template-columns: 1fr auto 1fr;
              gap: 12px;
              align-items: flex-start;
              padding-bottom: 12px; /* Add padding to ensure border is visible */
              margin-bottom: 12px;
            }

            /* Thick border separator below header for PDF visibility */
            // .prescription-header::after {
            //   content: '';
            //   position: absolute;
            //   left: 0;
            //   right: 0;
            //   bottom: 0;
            //   height: 3px;
            //   // background-color: #000000;
            //   width: 100%;
            // }

            /* Alternative: Add border-box wrapper for header */
            .prescription-header-wrapper {
              // border-bottom: 4px solid #000000;
              // padding-bottom: 8px;
              // margin-bottom: 12px;
            }

            /* Left: Doctor Info */
            .prescription-header__doctor {
              display: flex;
              flex-direction: column;
              gap: 2px;
            }
            .prescription-header__doctor-name {
              font-size: var(--prescription-font-size-xl);
              font-weight: 700;
              margin: 0;
            }
            .prescription-header__doctor-degrees,
            .prescription-header__doctor-regno,
            .prescription-header__doctor-phone {
              font-size: var(--prescription-font-size-sm);
              margin: 0;
            }

            /* Center: Logo */
            .prescription-header__logo {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100px; /* Constrain logo width */
            }
            .prescription-header__logo img {
              max-width: 100%;
              height: auto;
              max-height: 150px; /* Bigger logo */
              object-fit: contain;
            }

            /* Right: Clinic Info */
            .prescription-header__clinic {
              display: flex;
              flex-direction: column;
              gap: 2px;
              text-align: right;
            }
            .prescription-header__clinic-name {
              font-size: var(--prescription-font-size-xl);
              font-weight: 700;
              margin: 0;
            }
            .prescription-header__clinic-address,
            .prescription-header__clinic-phone,
            .prescription-header__clinic-timings {
              font-size: var(--prescription-font-size-sm);
              margin: 0;
              margin-left: auto;
              max-width: 220px;
            }

            /* Date - Floating right below header */
            .prescription-date-row {
              display: flex;
              justify-content: flex-end;
              margin-bottom: 8px;
            }
            .prescription-date {
              font-weight: 600;
              font-size: var(--prescription-font-size-base);
            }

            /* ============================================
               PATIENT DETAILS - SINGLE LINE
               ============================================ */
            .prescription-patient-bar {
              display: flex;
              flex-wrap: wrap;
              gap: 4px;
              padding-bottom: 4px;
              padding-top: 4px;
              margin-bottom: 12px;
              font-size: var(--prescription-font-size-base);
              font-weight: 700; /* Bold as per image */
            }
            .prescription-patient-bar__item::after {
              content: '/';
              margin: 0 6px;
              color: var(--prescription-text-color);
              font-weight: 400;
            }
            .prescription-patient-bar__item:last-child::after {
              content: '';
            }

            /* ============================================
               SECTIONS
               ============================================ */
            .prescription-section {
              margin-bottom: 12px; /* Increased padding */
              padding: 4px 6px; /* Add horizontal and vertical padding */
              position: relative;
            }
            .prescription-section__title {
              font-size: var(--prescription-font-size-header);
              font-weight: 700;
              margin-bottom: 4px;
            }
            .prescription-section__content {
              font-size: var(--prescription-font-size-sm);
              margin-bottom: 4px;
            }

            /* Lists - No bullets, left-aligned */
            ul {
              list-style: none;
              padding-left: 0;
              margin: 8px 0;
            }
            li {
              margin-bottom: 4px;
              padding-left: 0;
              text-align: left;
            }

            /* Tables (General) */
            table {
              border-collapse: collapse;
              width: 100%;
              margin-bottom: 8px;
              border: 1px solid #666666; /* Lighter border */
            }
            th, td {
              border: 1px solid #666666; /* Lighter gray border */
              padding: 8px 10px; /* Better padding for all tables */
              text-align: left; /* Left align for readability */
              vertical-align: top;
              font-size: var(--prescription-font-size-base);
            }
            th {
              font-weight: 700;
              background-color: #f5f5f5;
            }

            /* ============================================
               EYE PARAMETERS TABLE (Specific)
               ============================================ */
            .prescription-eye-table {
              width: 100%;
              border: 2px solid #666666; /* Lighter border */
              margin-bottom: 12px;
              border-collapse: collapse;
            }
            .prescription-eye-table th, 
            .prescription-eye-table td {
               marginTop: 5px;
               border: 1px solid #666666; /* Lighter gray border */
               padding: 8px 10px; /* Generous padding for eye tables */
               text-align: left; /* Left align */
               vertical-align: top;
               font-size: var(--prescription-font-size-base);
            }
            .prescription-eye-table th {
              font-weight: 700;
              background-color: #f8f8f8;
            }
            .prescription-parameters__group-title {
              font-weight: 700;
              font-size: var(--prescription-font-size-base);
              margin-bottom: 6px;
              display: block;
            }

            /* ============================================
               FOOTER
               ============================================ */
            .prescription-footer {
              margin-top: auto; 
              padding-top: 12px;
              display: flex;
              flex-direction: column;
              /* border-top: 1px solid var(--prescription-border-light); */
            }
            .prescription-footer__top {
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              margin-bottom: 12px;
            }
            
            /* Left: Follow up & QR */
            /* The image shows "Follow up" listed on the left, then QR code below/near it */
            .prescription-footer__left-block {
              display: flex;
              flex-direction: column;
              gap: 12px;
            }

            .prescription-footer__followup {
               font-weight: 700;
               font-size: var(--prescription-font-size-base);
            }

            .prescription-footer__qr {
              display: flex;
              align-items: center;
              gap: 8px;
            }
            .prescription-footer__qr-image {
              width: 90px; /* Bigger QR */
              height: 90px;
              object-fit: contain;
            }
            .prescription-footer__scan-text {
              font-size: var(--prescription-font-size-xs);
              max-width: 80px;
            }

            /* Right: Signature */
            .prescription-footer__signature {
              text-align: right;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 4px;
            }
            .prescription-footer__signature-image {
               max-height: 80px; /* Bigger signature */
               object-fit: contain;
            }
            .prescription-footer__signature-text {
              font-size: var(--prescription-font-size-sm);
            }

            /* Disclaimer */
            .prescription-footer__disclaimer {
              font-size: var(--prescription-font-size-xs);
              text-align: justify;
              margin-bottom: 4px;
              line-height: 1.1;
            }
            .prescription-footer__not_valid {
              margin-top: 5px;
              padding-bottom: 5px;
              margin-bottom: 10px;
              font-weight: bold;
              text-align: center;
            }

            /* ============================================
               FLEXIBLE GRID FOR COMPACT SECTIONS
               ============================================ */
            .prescription-compact-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 12px 16px;
              margin-bottom: 16px;
              page-break-inside: avoid;
            }

            .prescription-compact-grid .prescription-section {
              margin-bottom: 0;
              page-break-inside: avoid;
              break-inside: avoid;
              min-height: 40px;
            }

            .prescription-compact-grid .prescription-section__content {
              font-size: var(--prescription-font-size-base); /* Larger font for grid sections */
              line-height: 1.4;
            }

            .prescription-compact-grid .prescription-list {
              margin: 0;
              padding-left: 20px;
            }

            .prescription-compact-grid .prescription-list li {
              font-size: var(--prescription-font-size-base);
              margin-bottom: 4px;
              line-height: 1.4;
            }

            /* Ensure individual items don't break */
            .prescription-grid-card,
            .prescription-list li,
            .prescription-allergies__category {
              page-break-inside: avoid;
              break-inside: avoid;
            }

          `}
                    </style>

                    {/* HEADER SECTION */}
                    {printPreferences?.layoutPreferences?.showHeader !== false && (
                        <div className="prescription-header-wrapper"
                        >
                            <header className="prescription-header">
                                {(() => {
                                    const dd = getDisplayDoctor();
                                    return (
                                        <>
                                            <div className='prescription-header-content'>
                                                {/* Left: Doctor */}
                                                <div className="prescription-header__doctor">
                                                    <h1 className="prescription-header__doctor-name">{dd.name}</h1>
                                                    <div
                                                        className="prescription-header__doctor-degrees">{dd.degrees}</div>
                                                    {dd.registrationNo && (
                                                        <div
                                                            className="prescription-header__doctor-regno">Regno: {dd.registrationNo}</div>
                                                    )}
                                                    {dd.phone && (
                                                        <div className="prescription-header__doctor-phone">Ph
                                                            no: {dd.phone}</div>
                                                    )}
                                                </div>

                                                {/* Center: Logo */}
                                                <div className="prescription-header__logo">
                                                    {dd.clinic_icon && (
                                                        <img
                                                            alt="Logo"
                                                            src={dd.clinic_icon}
                                                            crossOrigin="anonymous"
                                                        />
                                                    )}
                                                </div>

                                                {/* Right: Clinic */}
                                                <div className="prescription-header__clinic">
                                                    <h2 className="prescription-header__clinic-name">{dd.clinicName || 'Clinic Name'}</h2>
                                                    {dd.clinicAddress && <div
                                                        className="prescription-header__clinic-address">{dd.clinicAddress}</div>}
                                                    {dd.clinicPhone &&
                                                        <div className="prescription-header__clinic-phone">Emergency Ph
                                                            no: {dd.clinicPhone}</div>}
                                                    {dd.clinicTimings && <div
                                                        className="prescription-header__clinic-timings">Timings: {dd.clinicTimings}</div>}
                                                </div>
                                            </div>

                                            {printPreferences?.layoutPreferences?.showPatientDetails !== false && (
                                                <div
                                                    // className="prescription-patient-bar"
                                                    style={{
                                                        display: 'flex',
                                                        width: '100%',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'baseline',
                                                        marginBottom: '12px',
                                                        fontWeight: '700',
                                                        fontSize: 'var(--prescription-font-size-base)',
                                                        borderTop: '2px solid #000000ff',
                                                        paddingBottom: '12px'
                                                    }}
                                                >
                                                    {/* Left: Patient Info */}
                                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                                                        {[
                                                            patientData?.patient_id,
                                                            patientData?.name,
                                                            patientData?.sex || patientData?.gender,
                                                            patientData?.phone_no || patientData?.phone,
                                                            patientData?.age ? `${patientData.age} Years` : null
                                                        ]
                                                            .filter(Boolean)
                                                            .map((val, idx, arr) => (
                                                                <span key={idx}
                                                                      style={{display: 'flex', alignItems: 'center'}}>
                                  {val}
                                                                    {idx < arr.length - 1 && (
                                                                        <span style={{
                                                                            margin: '0 6px',
                                                                            opacity: 0.5,
                                                                            fontWeight: '400'
                                                                        }}>/</span>
                                                                    )}
                                </span>
                                                            ))}
                                                    </div>

                                                    {/* Right: Date */}
                                                    <div className="prescription-date">
                                                        {consultationData.date || new Date().toLocaleDateString()}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    );
                                })()}


                            </header>
                            {/* Patient Details & Date Combined */}

                        </div>
                    )}

                    {/* CONTENT */}
                    <div className="prescription-content">


                        {printPreferences?.layoutPreferences?.showparameters !== false && renderParameters()}
                        {/* Compact Grid for 5 sections to prevent PDF cuts */}
                        <div className="prescription-compact-grid">
                            {printPreferences?.layoutPreferences?.showAllergies !== false && renderAllergies()}
                            {printPreferences?.layoutPreferences?.showClinicalFindings !== false && renderClinicalFindings()}
                            {renderDiagnosis()}
                            {printPreferences?.layoutPreferences?.showPastHistory !== false && renderPastHistory()}
                            {printPreferences?.layoutPreferences?.showComplaints !== false && renderComplaints()}
                        </div>
                        {printPreferences?.layoutPreferences?.showMedicines !== false && renderMedicines()}
                        {printPreferences?.layoutPreferences?.showAdvice !== false && renderAdvices()}
                        {printPreferences?.layoutPreferences?.showInvestigations !== false && renderInvestigations()}
                        {printPreferences?.layoutPreferences?.showPastMedications !== false && renderPastMedications()}
                        {printPreferences?.layoutPreferences?.showReferredTo !== false && renderReferral()}
                    </div>

                    {/* FOOTER */}
                    {printPreferences?.layoutPreferences?.showFooter !== false && (
                        <footer className="prescription-footer">
                            <div className="prescription-footer__top">
                                <div className="prescription-footer__left-block">
                                    {/* Follow Up */}
                                    {followUp && (
                                        <div className="prescription-footer__followup">
                                            {trHeader('followup', 'Follow up')}: {bulkTranslations[followUp] || localizeDigits(followUp, selectedLang)}
                                        </div>
                                    )}

                                    {/* QR Code */}
                                    <div className="prescription-footer__qr">
                                        {(() => {
                                            let qrSrc = doctorData?.doctor?.qr_code || doctorData?.qr_code || doctorData?.clinic?.qr_code || doctorData?.qrCodeUrl || null;
                                            if (!qrSrc) return null;
                                            const str = String(qrSrc);
                                            const isData = str.startsWith('data:');
                                            const looksBase64 = !isData && !/^http/.test(str) && str.length > 200;
                                            const finalSrc = looksBase64 ? `data:image/png;base64,${str}` : str;
                                            return <img src={finalSrc} alt="QR"
                                                        className="prescription-footer__qr-image"
                                                        crossOrigin="anonymous"/>;
                                        })()}
                                        <div className="prescription-footer__scan-text">
                                            <div>Scan to pay</div>
                                            {doctorData?.doctor?.upi_id && <div>UPI: {doctorData.doctor.upi_id}</div>}
                                        </div>
                                    </div>
                                </div>

                                {/* Signature */}
                                <div className="prescription-footer__signature">
                                    {(() => {
                                        const sigSrc = doctorData?.doctor?.doctor_signature || doctorData?.signature || null;
                                        if (sigSrc) {
                                            return <img src={sigSrc} alt="Sig"
                                                        className="prescription-footer__signature-image"
                                                        crossOrigin="anonymous"/>
                                        }
                                        return null;
                                    })()}
                                    <div className="prescription-footer__signature-text">Doctor Signature</div>
                                </div>
                            </div>

                            <div className="prescription-footer__disclaimer">
                                By accepting this e-prescription & invoice printout and receiving care, you consent to
                                the processing and secure storage of your health data by authorized third-party
                                technology providers (including Kifayti Health), solely for medical and lawful purposes,
                                in compliance with Indian data protection laws.
                            </div>
                            <div className="prescription-footer__not_valid">
                                NOT VALID FOR MEDICO-LEGAL PURPOSE
                            </div>
                        </footer>
                    )}
                </div>

                {/* Doctor Preferences Modal */}
                <DoctorModal
                    isOpen={isDoctorModalOpen}
                    onClose={closeDoctorModal}
                    onSubmit={handleDoctorModalSubmit}
                    initialData={printPreferences}
                />
            </div>
        </div>,
        document.body
    );

};


PreviewPageWYSIWYG.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    patientData: PropTypes.object,
    doctor: PropTypes.object,
    parametersData: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    allergiesData: PropTypes.array,
    complaints: PropTypes.array,
    diagnosis: PropTypes.array,
    medicinesData: PropTypes.array,
    advicesData: PropTypes.array,
    selectedLanguage: PropTypes.string,
    prescriptionData: PropTypes.object,
};

export default PreviewPageWYSIWYG;


/**
 * PreviewPageWYSIWYG - Advanced WYSIWYG Prescription Preview Component
 *
 * This is a sophisticated prescription preview component that renders consultation data
 * in a WYSIWYG (What You See Is What You Get) format with advanced PDF generation,
 * multi-language support, and comprehensive print management capabilities.
 *
 * Key Features:
 * - Real-time WYSIWYG preview of prescription layout
 * - Advanced PDF generation with section-based capture
 * - Multi-language support with localization for 10+ languages
 * - Intelligent medicine translation system
 * - Prescription saving and cloud storage integration
 * - Print preferences management with customizable layouts
 * - Doctor signature and clinic branding integration
 *
 * Advanced PDF Generation:
 * - html2canvas integration for high-quality rendering
 * - Section-based page flow with automatic page breaks
 * - Header replication across multiple pages
 * - Page numbering and margin management
 * - Canvas optimization for print quality
 * - Memory management and cleanup
 *
 * Multi-Language Support:
 * - 10+ language translations (Hindi, Bengali, Marathi, etc.)
 * - Medicine-specific translation database
 * - Digit localization (Arabic numerals to local scripts)
 * - Context-aware translation for medical terms
 * - Advice and instruction translation
 *
 * Props:
 * @param {boolean} isOpen - Modal visibility state
 * @param {Function} onClose - Callback to close the preview
 * @param {Object} patientData - Patient information
 * @param {Object} doctor - Doctor information
 * @param {Array|Object} parametersData - Vital signs and parameters
 * @param {Array} allergiesData - Patient allergies
 * @param {Array} complaints - Chief complaints
 * @param {Array} diagnosis - Diagnosis information
 * @param {Array} medicinesData - Prescription medicines
 * @param {Array} advicesData - Medical advice
 * @param {string} followUpDate - Next appointment date
 * @param {string} selectedLanguage - UI language preference
 * @param {Object} prescriptionData - Complete prescription data
 *
 * State Management:
 * - Multi-level data resolution priority system
 * - PDF generation states with error handling
 * - Language preference persistence
 * - Print preferences with localStorage integration
 * - Doctor data caching and profile management
 *
 * PDF Generation Process:
 * 1. Section capture using html2canvas
 * 2. Canvas analysis for content validation
 * 3. Intelligent page flow with header replication
 * 4. PDF assembly with jsPDF
 * 5. Blob creation for saving/preview
 *
 * Translation Architecture:
 * - Primary: Medicine-specific translation database
 * - Secondary: Local translation files
 * - Tertiary: API-based bulk translation
 * - Fallback: English default
 *
 * Data Resolution Priority:
 * 1. prescriptionData prop (highest priority)
 * 2. localStorage consultation data
 * 3. Individual component props
 * 4. Default/empty values
 *
 * Prescription Saving:
 * - PDF blob upload to cloud storage
 * - Prescription URL association with appointment
 * - Authentication token management
 * - Error handling with user feedback
 *
 * Print Preferences:
 * - Customizable section visibility
 * - Margin and layout controls
 * - Header/footer management
 * - QR code and signature placement
 *
 * Usage:
 * ```jsx
 * <PreviewPageWYSIWYG
 *   isOpen={showPreview}
 *   onClose={() => setShowPreview(false)}
 *   patientData={patient}
 *   medicinesData={medicines}
 *   advicesData={advice}
 *   selectedLanguage="hindi"
 *   prescriptionData={prescriptionData}
 * />
 * ```
 *
 * Browser Compatibility:
 * - Modern browsers with canvas support
 * - html2canvas compatibility layer
 * - Cross-origin handling for images
 * - Memory management for large documents
 *
 * Performance Optimizations:
 * - Canvas reuse and cleanup
 * - Blob URL management
 * - Translation caching
 * - Lazy loading of heavy components
 *
 * Security Features:
 * - Authentication token validation
 * - Secure file upload handling
 * - Input sanitization for translations
 * - Cross-origin resource protection
 *
 * @component
 * @since 1.0.0
 * @author himanshu
 */
// Optimize PDF generation by preloading assets and reducing redundant calls
// Preload fonts and images to reduce API calls
// Use optimized configurations for jsPDF and html2canvas
// Preload section canvases to avoid redundant rendering
// Log only essential details for debugging
// Exit early if no content is available
// Avoid unnecessary processing of non-essential elements
// Prioritize header detection for consistent layout
// Initialize currentY with top margin
// Optimize header rendering with caching
// Use high-quality rendering for header
// Adjust currentY after adding header
// Calculate space needed for each section
// Add header to new page if available
// Use optimized image rendering
// Log section addition for debugging
// Add page numbers with optimized font settings
// Handle download or preview based on user action
// Create blob URL for preview
// Ensure backward compatibility for preview
// Provide detailed error feedback
// Reset states after PDF generation